(function () {
  "use strict";

  /* ================= Kakbanner =================
     Visas INTE direkt vid första besöket. Tidigare mötte en ny besökare
     tre lager samtidigt: onboardingdialogen, stadväljaren bakom den, och
     kakbannern ovanpå båda. Bannern köas därför bakom onboardingen och
     visas först när den är stängd (showCookieBanner nedan anropas från
     closeOnboarding, eller direkt om onboardingen inte ska visas alls). */
  var showCookieBanner = (function initCookieBanner() {
    var KEY = "parkera_cookie_ack_v1";
    var banner = document.getElementById("cookieBanner");
    try {
      if (localStorage.getItem(KEY)) return function () {};
    } catch (e) { /* privat läge – visa ändå, men kan inte komma ihåg valet */ }
    document.getElementById("cookieOk").addEventListener("click", function () {
      try { localStorage.setItem(KEY, "1"); } catch (e) {}
      banner.hidden = true;
    });
    return function () { banner.hidden = false; };
  })();

  /* ================= PWA ================= */
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
      // updateViaCache: "none" tvingar webbläsaren att alltid hämta sw.js
      // (och ev. importScripts-resurser däri) direkt från nätverket, och
      // ignorera HTTP-cache helt för just den filen – ett skyddslager
      // utöver Cache-Control-headern i .htaccess, ifall en mellanliggande
      // CDN eller proxy skulle cacha den ändå.
      navigator.serviceWorker.register("sw.js", { updateViaCache: "none" }).catch(function () {});
    });
  }

  /* ================= Ikoner =================
     Gränssnittet blandade tidigare två ikonsystem: streckade SVG-ikoner i
     verktygsraden och emoji överallt annars (🅿️ ⏱️ 📍 ☰ ⚖ 📤 ⚠ 🚲 🏍 🚐 ♿).
     Emoji renderas av operativsystemets egen färgfont – olika form på
     iOS/Android/Windows, alltid i sin egen färg, och de ärver därför
     varken currentColor eller temat. På kartmarkörer, där de låg ovanpå
     en färgad platta, betydde det att symbolen kunde bli oläslig på vissa
     plattformar. Allt ritas nu med samma SVG-uppsättning som resten. */
  var ICON_PATHS = {
    zap: '<path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/>',
    bike: '<circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/>' +
          '<path d="M15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/><path d="M12 17.5 8.5 9l3-2.5 2 3.5h3"/>',
    access: '<circle cx="13" cy="4" r="2"/><path d="M11 8.5 10.5 13H15l3 6"/>' +
            '<path d="M14 13a5.5 5.5 0 1 1-5.2 3.7"/>',
    psign: '<rect x="3" y="3" width="18" height="18" rx="4"/><path d="M9.5 17V7.5h3.2a2.9 2.9 0 0 1 0 5.8H9.5"/>',
    pin: '<path d="M12 21s7-6.4 7-11a7 7 0 1 0-14 0c0 4.6 7 11 7 11z"/><circle cx="12" cy="10" r="2.6"/>'
  };
  function icon(name, size) {
    return '<svg class="ico" viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none" ' +
      'stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true">' + ICON_PATHS[name] + "</svg>";
  }

  /* ================= Karta ================= */
  /* ================= Dynamisk layout-mätning =================
     rememberBtn/timerBtn/rememberBanner/timerBanner positioneras
     relativt headerns FAKTISKA höjd (--header-h), inte ett hårdkodat
     pixelvärde – det var precis vad som gick sönder när fler filterchips
     lades till i v12 och chip-raden började radbryta till två rader på
     många skärmbredder. Mäts på load, resize och varje gång chippen kan
     tänkas ändra rad (t.ex. filterval som byter text). */
  function updateHeaderHeightVar() {
    var header = document.querySelector("header");
    if (header) {
      document.documentElement.style.setProperty("--header-h", header.getBoundingClientRect().height + "px");
    }
  }
  window.addEventListener("resize", updateHeaderHeightVar);
  window.addEventListener("load", updateHeaderHeightVar);

  var map = L.map("map", { zoomControl: false }).setView([62.5, 16.5], 5);
  L.control.zoom({ position: "bottomright" }).addTo(map);

  /* Kartlagret bytte tidigare aldrig utseende med temat – kartan (som
     upptar merparten av skärmen) förblev skarpt vit även i mörkt läge,
     vilket gjorde hela mörka temat kännas halvfärdigt/trasigt eftersom
     den absolut största ytan på skärmen ändå lyste vit. CartoDB Dark
     Matter är en gratis, nyckelfri mörk kartstil (samma OSM-underlag,
     bara mörkt färgad) som byts in när temat är mörkt. */
  var TILE_URLS = {
    light: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    dark: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
  };
  var TILE_ATTR = {
    light: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-bidragsgivare',
    dark: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-bidragsgivare ' +
      '&copy; <a href="https://carto.com/attributions">CARTO</a>'
  };
  var tileLayer = L.tileLayer(TILE_URLS[currentlyDark() ? "dark" : "light"], {
    maxZoom: 19,
    attribution: TILE_ATTR[currentlyDark() ? "dark" : "light"]
  }).addTo(map);

  function updateTileLayerForTheme(dark) {
    map.removeLayer(tileLayer);
    tileLayer = L.tileLayer(TILE_URLS[dark ? "dark" : "light"], {
      maxZoom: 19,
      attribution: TILE_ATTR[dark ? "dark" : "light"]
    }).addTo(map);
  }

  var layer = L.layerGroup().addTo(map);
  var chargerLayer = L.layerGroup();
  var bicycleLayer = L.layerGroup();
  var disabledLayer = L.layerGroup();
  /* Taxefärgade gatusträckor. Ligger i ett eget lager under markörerna
     (se pane-inställningen nedan) så att linjerna aldrig kan fånga ett
     klick som var avsett för en parkeringsmarkör. */
  var tariffLayer = L.layerGroup();
  var zoneLayer = L.markerClusterGroup({
    maxClusterRadius: 50,
    disableClusteringAtZoom: 17,
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false,
    iconCreateFunction: function (cluster) {
      return L.divIcon({
        className: "",
        html: '<div class="zcluster">' + cluster.getChildCount() + "</div>",
        iconSize: [34, 34]
      });
    }
  }).addTo(map);
  var allSpots = [];
  var favorites = {};
  var activeFilter = "all";
  var showChargers = false;
  var showBicycles = false;
  var showDisabled = false;
  var lastLtfZones = [];
  var destination = null; // {lat, lon, name} från adressökning
  var destMarker = null;

  var statusEl = document.getElementById("status");
  var citiesEl = document.getElementById("cities");
  var hereBtn = document.getElementById("hereBtn");
  var favPanel = document.getElementById("favPanel");
  var favList = document.getElementById("favList");
  var listPanel = document.getElementById("listPanel");
  var listBody = document.getElementById("listBody");
  var statusTimer = null;

  /* ================= Hjälpare ================= */
  function showStatus(msg, sticky) {
    statusEl.textContent = msg;
    statusEl.style.display = "block";
    clearTimeout(statusTimer);
    if (!sticky) statusTimer = setTimeout(hideStatus, 4000);
  }
  function hideStatus() { statusEl.style.display = "none"; }
  function hideCities() { citiesEl.style.display = "none"; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }
  function favKey(s) { return s.osm_type + "/" + s.osm_id; }
  function haversine(lat1, lon1, lat2, lon2) {
    var r = 6371000, dLat = (lat2 - lat1) * Math.PI / 180, dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * r * Math.asin(Math.min(1, Math.sqrt(a)));
  }
  // Gå-tid: fågelväg × 1.3 (gatunät), 5 km/h
  function walkMinutes(meters) { return Math.max(1, Math.round(meters * 1.3 / 83.3)); }

  function api(path, options) {
    return fetch("api/" + path, options).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.error || "HTTP " + r.status);
        return data;
      });
    });
  }

  /* ================= Öppettider & villkorad avgift =================
     Enkel tolk för vanliga opening_hours-mönster:
     "24/7", "Mo-Fr 08:00-18:00; Sa 09:00-15:00", "Mo-Su 07:00-22:00" osv.
     Klarar inte månader/helgdagar – returnerar då null (okänt).           */
  var DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

  function evalOpeningHours(spec, date) {
    if (!spec) return null;
    spec = spec.trim();
    if (spec === "24/7") return true;
    if (/PH|SH|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|week|sunrise|sunset/.test(spec)) return null;

    var day = DAYS[date.getDay()];
    var minutes = date.getHours() * 60 + date.getMinutes();
    var open = false, matchedAnyRule = false;

    var rules = spec.split(";");
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i].trim();
      if (!rule) continue;
      var isOff = /\boff\b|\bclosed\b/.test(rule);
      rule = rule.replace(/\boff\b|\bclosed\b/g, "").trim();

      // Dagdel (allt före första siffran), tidsdel (resten)
      var m = rule.match(/^([A-Za-z,\- ]*)(.*)$/);
      var dayPart = (m[1] || "").trim();
      var timePart = (m[2] || "").trim();

      var dayMatch;
      if (!dayPart) {
        dayMatch = true; // ingen dagangivelse = alla dagar
      } else {
        dayMatch = false;
        var groups = dayPart.split(",");
        for (var g = 0; g < groups.length; g++) {
          var grp = groups[g].trim();
          if (!grp) continue;
          var range = grp.split("-");
          var a = DAYS.indexOf(range[0]);
          var b = range.length > 1 ? DAYS.indexOf(range[1]) : a;
          if (a === -1 || b === -1) return null; // okänt format
          var d = DAYS.indexOf(day);
          if (a <= b ? (d >= a && d <= b) : (d >= a || d <= b)) { dayMatch = true; break; }
        }
      }
      if (!dayMatch) continue;
      matchedAnyRule = true;
      if (isOff) { open = false; continue; }

      if (!timePart) { open = true; continue; }
      var spans = timePart.split(",");
      var inSpan = false;
      for (var s = 0; s < spans.length; s++) {
        var t = spans[s].trim().match(/^(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
        if (!t) return null;
        var from = (+t[1]) * 60 + (+t[2]);
        var to = (+t[3]) * 60 + (+t[4]);
        if (to <= from) { // över midnatt
          if (minutes >= from || minutes < to) inSpan = true;
        } else if (minutes >= from && minutes < to) inSpan = true;
      }
      open = inSpan;
    }
    return matchedAnyRule ? open : false;
  }

  /* fee:conditional, t.ex. "no @ (Su)" eller "yes @ (Mo-Fr 08:00-18:00)"  */
  function feeRightNow(s, date) {
    var t = s.tags || {};
    var cond = t["fee:conditional"];
    if (cond) {
      var m = cond.match(/^\s*(yes|no)\s*@\s*\((.+)\)\s*$/);
      if (m) {
        var applies = evalOpeningHours(m[2].trim(), date);
        if (applies === true) return m[1] === "yes";
        if (applies === false) return s.fee === "yes";
      }
      return null;
    }
    // fee=yes + opening_hours på avgiften? OSM använder ibland "fee=yes" med
    // taxans tider i "charge"/"opening_hours" – vi nöjer oss med fee-fältet.
    if (s.fee === "yes") return true;
    if (s.fee === "no") return false;
    return null;
  }

  function nowBadges(s) {
    var now = new Date();
    var html = "";
    var t = s.tags || {};

    if (t.opening_hours) {
      var open = evalOpeningHours(t.opening_hours, now);
      if (open === true) html += '<span class="nowbadge ok"><span class="pulse"></span>Öppet nu</span>';
      else if (open === false) html += '<span class="nowbadge bad"><span class="pulse"></span>Stängt nu</span>';
    }
    if (t["fee:conditional"]) {
      var fee = feeRightNow(s, now);
      if (fee === true) html += '<span class="nowbadge bad">Avgift just nu</span>';
      else if (fee === false) html += '<span class="nowbadge ok">Gratis just nu</span>';
    }
    return html;
  }

  /* ================= Kategorisering ================= */
  function categorize(s) {
    var t = s.tags || {};
    return {
      pr: !!s.park_ride,
      garage: ["multi-storey", "underground", "rooftop"].indexOf(s.parking_type) !== -1
        || t.building === "parking",
      pay: s.fee === "no" ? "free" : s.fee === "yes" ? "paid" : "unknown",
      priv: s.access_level === "private" || s.access_level === "no",
      charging: (s.capacity_charging || 0) > 0,
      mc: t.motorcycle === "yes" || t.motorcycle === "designated" || s.parking_type === "motorcycle_parking",
      husbil: t.motorhome === "yes" || t.motorhome === "designated" || t.caravans === "yes"
    };
  }
  function markerColor(c) {
    if (c.priv) return "#6B7684";
    if (c.pr) return "#6B4FA0";
    if (c.pay === "free") return "#1E8A4C";
    if (c.pay === "paid") return "#C97B10";
    return "#0D5EAF";
  }
  /* Bokstaven visar TYP (G=garage/parkeringshus, P=övrigt – mark-/gatu-
     parkering, infart m.m.), medan färgen (markerColor ovan) fortsätter
     visa avgiftsstatus – två oberoende dimensioner i samma markör, i
     stället för att välja bort den ena. Laddstationer och cykelparkering
     har redan egna symboler i sina egna lager (⚡/🚲). */
  function markerLetter(c) {
    return c.garage ? "G" : "P";
  }
  function matchesFilter(s) {
    var c = s.cat;
    switch (activeFilter) {
      case "free": return c.pay === "free" && !c.priv;
      case "paid": return c.pay === "paid";
      case "garage": return c.garage;
      case "pr": return c.pr;
      case "opennow":
        var oh = (s.tags || {}).opening_hours;
        return !oh || evalOpeningHours(oh, new Date()) !== false;
      case "mc": return c.mc;
      case "husbil": return c.husbil;
      default: return true;
    }
  }

  /* ================= Crowdsourcad snabbrapportering ================= */
  var QUICK_LABELS = { empty: "Gott om plats", some: "Ganska fullt", full: "Fullt" };
  var QUICK_COLORS = { empty: "#1E8A4C", some: "#C97B10", full: "#B03434" };

  function quickOccupancyHtml(s) {
    var html = '<div class="quickbox" data-k="' + favKey(s) + '">';
    if (s.quick_occupancy) {
      var q = s.quick_occupancy;
      html += '<div class="quicknow" style="color:' + QUICK_COLORS[q.status] + '">' +
        "● " + QUICK_LABELS[q.status] + ' <small>(' + q.count + " rapport" + (q.count > 1 ? "er" : "") +
        ", senast " + esc(String(q.updated_at).slice(11, 16)) + ")</small></div>";
    }
    html += '<div class="quickask">Hur ser det ut just nu?' +
      '<div class="quickbtns">' +
      '<button data-status="empty"><span class="qdot qdot--empty"></span>Gott om plats</button>' +
      '<button data-status="some"><span class="qdot qdot--some"></span>Ganska fullt</button>' +
      '<button data-status="full"><span class="qdot qdot--full"></span>Fullt</button>' +
      "</div></div></div>";
    return html;
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".quickbtns button");
    if (!btn) return;
    var box = btn.closest(".quickbox");
    var key = box.dataset.k.split("/");
    api("quick_occupancy.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ osm_type: key[0], osm_id: +key[1], status: btn.dataset.status })
    }).then(function (d) {
      showStatus(d.message || "Tack för din rapport!");
      var now = box.querySelector(".quicknow");
      var html = '<div class="quicknow" style="color:' + QUICK_COLORS[d.status] + '">' +
        "● " + QUICK_LABELS[d.status] + ' <small>(' + d.count + " rapport" + (d.count > 1 ? "er" : "") + ", nyss)</small></div>";
      if (now) now.outerHTML = html; else box.insertAdjacentHTML("afterbegin", html);
    }).catch(function (err) { showStatus(err.message); });
  });

  /* ================= Betaltjänster ================= */
  var PLATE_KEY = "parkera_plate_v1";
  function getPlate() {
    try { return localStorage.getItem(PLATE_KEY) || ""; } catch (e) { return ""; }
  }
  function setPlate(v) {
    try {
      v = v.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 7);
      if (v) localStorage.setItem(PLATE_KEY, v); else localStorage.removeItem(PLATE_KEY);
      return v;
    } catch (e) { return v; }
  }

  var PROVIDERS = {
    easypark: { name: "EasyPark", color: "#E6007E",
      web: "https://web.easypark.net/", webLabel: "Öppna EasyPark Web" },
    parkster: { name: "Parkster", color: "#0091C9",
      web: "https://www.parkster.com/se/", webLabel: "Om Parkster",
      sms: "0707131415", smsLabel: "Starta via SMS" },
    epark:    { name: "ePARK", color: "#3D9B4F", web: "https://epark.se/", webLabel: "Öppna ePARK" },
    mobill:   { name: "Mobill", color: "#5A5A8F", web: "https://mobill.se/", webLabel: "Öppna Mobill" },
    aimo:     { name: "Aimo Park", color: "#00A88E", web: "https://www.aimopark.se/", webLabel: "Öppna Aimo Park" },
    apcoa:    { name: "APCOA FLOW", color: "#D22630", web: "https://www.apcoa.se/", webLabel: "Öppna APCOA" },
    annan:    { name: "Betaltjänst", color: "#6B7684", web: null }
  };

  function paySectionHtml(s) {
    var zones = s.pay_zones || [];
    var occ = s.occupancy || {};
    // Officiell zonkod från stads-API (t.ex. Stockholm Parkering) utan angiven tjänst
    if (!zones.length && !occ.zone_code && !occ.taxa) return "";

    var html = '<div class="paybox"><div class="paytitle">Betala parkeringen</div>';

    if (occ.taxa) {
      html += '<div class="paytaxa">Taxa: <strong>' + esc(occ.taxa) + "</strong></div>";
    }
    if (occ.zone_code && !zones.length) {
      html += payZoneRow({ provider: "annan", zone_code: occ.zone_code, price_info: null });
    }
    zones.forEach(function (z) { html += payZoneRow(z); });

    html += '<div class="platerow">Reg.nr: <input type="text" class="plateinput" maxlength="7" ' +
      'placeholder="ABC123" value="' + esc(getPlate()) + '"> <small>sparas bara i din webbläsare</small></div>';
    html += '<small class="paynote">Kontrollera alltid att zonkoden stämmer med skylten på platsen.</small></div>';
    return html;
  }

  document.addEventListener("change", function (e) {
    if (e.target.classList && e.target.classList.contains("plateinput")) {
      var v = setPlate(e.target.value);
      e.target.value = v;
      document.querySelectorAll(".plateinput").forEach(function (i) { i.value = v; });
    }
  });

  var providerStatus = {}; // "easypark" -> {configured, partner_url}
  function loadProviderStatus() {
    api("payment_providers.php").then(function (d) {
      (d.providers || []).forEach(function (p) {
        providerStatus[p.name.toLowerCase()] = p;
      });
    }).catch(function () {});
  }

  function payZoneRow(z) {
    var p = PROVIDERS[z.provider] || PROVIDERS.annan;
    var plate = getPlate();
    var status = providerStatus[z.provider];
    var html = '<div class="payrow">' +
      '<span class="paydot" style="background:' + p.color + '"></span>' +
      '<span class="payname">' + esc(p.name) + "</span>" +
      '<button class="paycode" data-copy="' + esc(z.zone_code) + '" title="Kopiera zonkod">' +
      esc(z.zone_code) + "</button>";
    if (status && status.configured) {
      // Riktigt partneravtal finns – visa en faktisk starta-knapp.
      html += '<button class="paybtn startbtn" data-provider="' + esc(z.provider) +
        '" data-zone="' + esc(z.zone_code) + '">Starta parkering nu</button>';
    }
    if (p.sms) {
      var body = plate ? z.zone_code + " " + plate + " " : z.zone_code + " ";
      html += '<a class="paybtn" href="sms:' + p.sms + "?&body=" +
        encodeURIComponent(body) + '">' + p.smsLabel + "</a>";
    }
    if (p.web) {
      html += '<a class="paybtn" href="' + p.web + '" target="_blank" rel="noopener">' +
        (p.webLabel || "Öppna") + "</a>";
    }
    html += "</div>";
    if (z.price_info) html += '<div class="payprice">' + esc(z.price_info) + "</div>";
    return html;
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".startbtn");
    if (!btn) return;
    var plate = getPlate();
    if (!plate) { showStatus("Fyll i reg.nr först."); return; }
    btn.disabled = true;
    api("payment_providers.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ provider: btn.dataset.provider, zone_code: btn.dataset.zone, plate: plate })
    }).then(function () {
      showStatus("Parkering startad!");
    }).catch(function (err) {
      showStatus(err.message);
      btn.disabled = false;
    });
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".paycode");
    if (!btn) return;
    var code = btn.dataset.copy;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        showStatus("Zonkod " + code + " kopierad!");
      });
    } else {
      showStatus("Zonkod: " + code);
    }
  });

  /* ================= Popup ================= */
  var typeNames = {
    surface: "Markparkering", "multi-storey": "Parkeringshus",
    underground: "Garage (under mark)", rooftop: "Takparkering",
    street_side: "Gatuparkering", lane: "Gatuparkering"
  };
  var accessNames = {
    yes: "Öppen för alla", public: "Öppen för alla", customers: "Endast kunder",
    private: "Privat", permissive: "Öppen (privat mark)", no: "Ej tillgänglig",
    destination: "Besökare", permit: "Kräver tillstånd"
  };

  /* Waze har inget publikt API för att hämta trafik/beläggningsdata (bara
     deras Connected Citizens-partnerprogram, samma modell som p-bolagen) –
     men de har en väldokumenterad, stabil deep link-URL för navigering,
     så det är vad vi kan koppla in utan avtal. */
  function directionLinksHtml(lat, lon) {
    return '<a href="https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lon +
      '" target="_blank" rel="noopener">Google Maps</a>' +
      ' <a href="https://www.waze.com/ul?ll=' + lat + ',' + lon +
      '&navigate=yes&zoom=17" target="_blank" rel="noopener">Waze</a>';
  }

  /* ================= Stockholms taxeområden =================
     Popupen visade tidigare bara den råa taxatexten från LTF-API:et
     ("taxa 5: 5 kr/tim vardagar 7-19, Boende: 300 kr/månad …") och lämnade
     åt användaren att räkna ut om det kostar något just nu. Det är den
     enda frågan man faktiskt har när man står med bilen. Tabellen nedan
     är Stockholms stads publicerade taxor (parkering.stockholm,
     Trafikkontorets taxebestämmelser) – siffrorna är stadens, uträkningen
     är vår.

     VIKTIGT om "vardag": stadens taxor skiljer på vanlig vardag och
     "vardag före sön- och helgdag" (lördagar, och t.ex. skärtorsdag före
     långfredag). Det går alltså INTE att bara kolla getDay() – därav
     helgdagsberäkningen nedan. Blir den fel visar popupen fel pris på
     precis de dagar då folk är mest osäkra, vilket är värre än att inte
     visa något pris alls.

     Skyltningen på gatan gäller alltid före det här. */
  var STOCKHOLM_TARIFFS = {
    1: { color: "#0E7C74", price: "55 kr/tim",
         hours: "55 kr/tim dygnet runt, alla dagar inklusive lördag, söndag och helgdag." },
    2: { color: "#B03A70", price: "31 kr/tim",
         hours: "Vardag: 31 kr/tim 07–21, övrig tid 20 kr/tim. Vardag före sön-/helgdag samt sön-/helgdag: 31 kr/tim 09–19, övrig tid 20 kr/tim. Avgift dygnet runt." },
    3: { color: "#2F6FA8", price: "20 kr/tim",
         hours: "Vardag: 20 kr/tim 07–19. Vardag före sön-/helgdag: 15 kr/tim 11–17. Övrig tid avgiftsfritt." },
    4: { color: "#6B4FA0", price: "10 kr/tim",
         hours: "Vardag: 10 kr/tim 07–19. Vardag före sön-/helgdag: 10 kr/tim 11–17. Övrig tid avgiftsfritt." },
    5: { color: "#B8590A", price: "5 kr/tim",
         hours: "Vardag: 5 kr/tim 07–19. Övrig tid, inklusive lördag, söndag och helgdag: avgiftsfritt." }
  };

  /* Påskdagen enligt den anonyma gregorianska algoritmen. Alla rörliga
     svenska helgdagar utom midsommar och alla helgons dag räknas från
     den. */
  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }
  function ymd(d) { return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate(); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }

  /* Lördagen i ett givet datumintervall (midsommardagen 20–26 juni,
     alla helgons dag 31 okt–6 nov). */
  function saturdayBetween(year, month, fromDay, toDay) {
    for (var day = fromDay; day <= toDay; day++) {
      var d = new Date(year, month, day);
      if (d.getDay() === 6) return d;
    }
    return null;
  }

  var holidayCache = {};
  function swedishHolidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    var easter = easterSunday(year);
    var days = [
      new Date(year, 0, 1),      // nyårsdagen
      new Date(year, 0, 6),      // trettondedag jul
      addDays(easter, -2),       // långfredagen
      easter,                    // påskdagen
      addDays(easter, 1),        // annandag påsk
      new Date(year, 4, 1),      // första maj
      addDays(easter, 39),       // Kristi himmelsfärds dag
      addDays(easter, 49),       // pingstdagen
      new Date(year, 5, 6),      // nationaldagen
      saturdayBetween(year, 5, 20, 26),   // midsommardagen
      saturdayBetween(year, 9, 31, 31) || saturdayBetween(year, 10, 1, 6), // alla helgons dag
      new Date(year, 11, 25),    // juldagen
      new Date(year, 11, 26)     // annandag jul
    ];
    var set = {};
    days.forEach(function (d) { if (d) set[ymd(d)] = true; });
    holidayCache[year] = set;
    return set;
  }
  function isHoliday(d) { return !!swedishHolidays(d.getFullYear())[ymd(d)]; }

  /* Returnerar { amount, label, free } för en taxa vid en given tidpunkt. */
  function tariffPriceNow(taxa, when) {
    var d = when || new Date();
    var hour = d.getHours() + d.getMinutes() / 60;
    var sundayOrHoliday = d.getDay() === 0 || isHoliday(d);
    // Lördag räknas som "vardag före sön-/helgdag", liksom en vardag vars
    // nästa dag är helgdag.
    var beforeSunOrHoliday = !sundayOrHoliday && (d.getDay() === 6 || isHoliday(addDays(d, 1)));
    var plainWeekday = !sundayOrHoliday && !beforeSunOrHoliday && d.getDay() >= 1 && d.getDay() <= 5;

    function paid(kr) { return { amount: kr, free: false, label: kr + " kr/tim just nu" }; }
    var free = { amount: 0, free: true, label: "Avgiftsfritt just nu" };

    if (taxa === 1) return paid(55);
    if (taxa === 2) {
      if (plainWeekday) return hour >= 7 && hour < 21 ? paid(31) : paid(20);
      return hour >= 9 && hour < 19 ? paid(31) : paid(20);
    }
    if (taxa === 3) {
      if (plainWeekday && hour >= 7 && hour < 19) return paid(20);
      if (beforeSunOrHoliday && hour >= 11 && hour < 17) return paid(15);
      return free;
    }
    if (taxa === 4) {
      if (plainWeekday && hour >= 7 && hour < 19) return paid(10);
      if (beforeSunOrHoliday && hour >= 11 && hour < 17) return paid(10);
      return free;
    }
    if (taxa === 5) {
      if (plainWeekday && hour >= 7 && hour < 19) return paid(5);
      return free;
    }
    return null;
  }

  /* Taxenumret står i LTF-textens PARKING_RATE-del ("taxa 5: 5 kr/tim …").
     Ingen schemaändring behövs alltså – siffran finns redan i datan vi
     hämtar, den har bara aldrig lästs ut. */
  function tariffFromSpot(s) {
    if (!s.ltf || !s.ltf.length) return null;
    for (var i = 0; i < s.ltf.length; i++) {
      var m = /\btaxa\s*([1-5])\b/i.exec(s.ltf[i].info || "");
      if (m) return parseInt(m[1], 10);
    }
    return null;
  }

  function popupHtml(s) {
    var t = s.tags || {}, c = s.cat;
    var isFav = !!favorites[favKey(s)];
    var name = s.name || (c.garage ? "Parkeringshus" : "Parkering");
    /* Titelblocket: typikon i kategorifärg, en kicker som säger VAD det är,
       namnet, och först därefter etiketterna. Tidigare låg allt på samma
       nivå – rubrik och sex likadana etiketter – så det fanns ingen
       ordning att läsa i. */
    var taxa = tariffFromSpot(s);
    var kicker = c.garage ? "Parkeringshus" : c.pr ? "Infartsparkering" :
      c.charging ? "Laddplats" : (typeNames[s.parking_type] || "Parkering");
    var headIcon = c.charging ? "zap" : "psign";

    var html = '<div class="pp" data-k="' + favKey(s) + '">' +
      '<div class="pphead">' +
      '<span class="pptype' + (c.garage ? " is-garage" : c.pay === "free" ? " is-free" : "") + '">' +
      icon(headIcon, 20) + "</span>" +
      "<div class=\"pptitle\"><small>" + esc(kicker) + "</small><h3>" + esc(name) + "</h3></div>" +
      '<button class="star' + (isFav ? " on" : "") + '" data-k="' + favKey(s) +
      '" title="Spara som favorit" aria-label="Spara som favorit">★</button></div>';

    if (taxa) {
      html += '<span class="tag tag--taxa" style="background:' + STOCKHOLM_TARIFFS[taxa].color +
        '">Taxa ' + taxa + "</span>";
    }
    if (c.pr) html += '<span class="tag tag--pr">Infartsparkering</span>';
    if (c.pay === "free") html += '<span class="tag tag--free">Gratis</span>';
    if (c.pay === "paid") html += '<span class="tag tag--paid">Avgift</span>';
    if (c.priv) html += '<span class="tag tag--priv">Privat</span>';
    if (c.garage) html += '<span class="tag tag--garage">P-hus</span>';
    if (c.charging) html += '<span class="tag tag--charging">Laddplats</span>';
    html += nowBadges(s);

    /* "Vad kostar det just nu" – den enda fråga man faktiskt har när man
       står med bilen. Räknas ut i webbläsaren, så siffran är korrekt även
       för ett svar som legat i offline-cachen sedan i går. */
    if (taxa) {
      var now = tariffPriceNow(taxa);
      html += '<div class="ppnow' + (now.free ? " is-free" : "") + '">' +
        '<strong>' + esc(now.label) + "</strong>" +
        "<small>Taxa " + taxa + " · " + esc(STOCKHOLM_TARIFFS[taxa].price) + " ordinarie</small></div>";
    }

    // Realtidsbeläggning
    if (s.occupancy && s.occupancy.free != null) {
      var low = s.occupancy.total && s.occupancy.free / s.occupancy.total < 0.1;
      html += '<div class="occ' + (low ? " low" : "") + '" data-occ-hist="' +
        esc(s.occupancy.source || "") + "/" + esc(s.occupancy.external_id || "") + '">' +
        s.occupancy.free + " lediga platser" +
        (s.occupancy.total ? " av " + s.occupancy.total : "") +
        "<small>Uppdaterad " + esc(String(s.occupancy.updated_at).slice(11, 16)) + "</small>" +
        '<span class="occtypical"></span></div>';
    }

    html += paySectionHtml(s);
    html += quickOccupancyHtml(s);
    html += ltfSectionHtml(s);

    /* Faktarutnät i stället för en åtta rader hög <table>. Etikett över
       värde, i ett rutnät som bryter av sig självt – går att skanna på en
       telefon i stället för att läsas rad för rad. Långa fritextvärden
       (öppettider, taxatext, operatör) får spänna hela bredden; klämda in
       i en smal kolumn blev de tre rader höga var. */
    var facts = [];
    function fact(label, value, wide) {
      if (value === null || value === undefined || value === "") return;
      facts.push('<div class="ppfact' + (wide ? " is-wide" : "") + '"><small>' +
        esc(label) + "</small><strong>" + esc(String(value)) + "</strong></div>");
    }

    if (destination) {
      var dm = Math.round(haversine(s.lat, s.lon, destination.lat, destination.lon));
      fact("Till målet", "~" + walkMinutes(dm) + " min gång");
      fact("Avstånd", dm + " m");
    } else if (s.dist_m != null) {
      fact("Avstånd", s.dist_m + " m");
    }
    if (s.capacity) fact("Platser", s.capacity);
    if (s.capacity_disabled) fact("RH-platser", s.capacity_disabled);
    if (s.capacity_charging) fact("Laddplatser", s.capacity_charging);
    if (t.maxstay) fact("Maxtid", t.maxstay);
    if (accessNames[s.access_level]) fact("Tillgång", accessNames[s.access_level]);
    if (t.opening_hours) fact("Öppet", t.opening_hours, true);
    if (t.operator) fact("Operatör", t.operator, true);

    if (facts.length) html += '<div class="ppfacts">' + facts.join("") + "</div>";

    /* Först det man faktiskt öppnade popupen för: vägbeskrivning och de
       direkta handlingarna. */
    /* Två nivåer i stället för en rad likadana understrukna länkknappar:
       "Parkera här" är den handling man kom hit för och ser ut som det,
       resten är sekundärt. */
    html += '<div class="ppactions">' +
      '<button class="ppprimary parkherebtn" data-act="parkhere" data-k="' + favKey(s) +
      '" data-lat="' + s.lat + '" data-lon="' + s.lon + '" data-name="' + esc(name) + '">' +
      icon("psign", 17) + "Parkera här</button></div>" +
      '<div class="ppfoot">' +
      directionLinksHtml(s.lat, s.lon) +
      '<button class="linkbtn" data-act="compare" data-k="' + favKey(s) + '">Jämför</button>' +
      '<button class="linkbtn" data-act="share" data-k="' + favKey(s) + '">Dela</button>' +
      "</div>";

    /* Prisrapport, betygsformulär och felanmälan är tre FORMULÄR. De låg
       tidigare utfällda samtidigt mitt i popupen och konkurrerade med
       informationen man kom för – på en telefon innebar det att man fick
       scrolla förbi tre inmatningsfält för att se om parkeringen ens var
       gratis. De ligger nu bakom en gemensam <details>, som dessutom är
       ärlig mot vad de är: frivilliga bidrag, inte en del av uppslaget.
       Sammanfattningarna (pris/betyg) hämtas fortfarande asynkront och
       visas när man fäller ut. */
    html += '<details class="ppcontrib"><summary>Bidra med information</summary>' +
      '<div class="price" data-price-for="' + favKey(s) + '">Hämtar prisrapporter…</div>' +
      '<div class="ratingbox" data-rating-for="' + favKey(s) + '">' +
      '<div class="ratingsummary muted">Hämtar betyg…</div>' +
      '<div class="ratingform" data-osm-type="' + s.osm_type + '" data-osm-id="' + s.osm_id + '">' +
      '<span class="ratingq">Belysning<button type="button" data-q="lighting_good" data-v="" aria-label="Belysning">–</button></span>' +
      '<span class="ratingq">Känns tryggt<button type="button" data-q="feels_safe" data-v="" aria-label="Känns tryggt">–</button></span>' +
      '<span class="ratingq">Skyltning stämmer<button type="button" data-q="signage_accurate" data-v="" aria-label="Skyltning stämmer">–</button></span>' +
      '<button type="button" class="ratingsubmit linkbtn">Skicka betyg</button>' +
      "</div></div>" +
      '<button class="linkbtn" data-act="report" data-k="' + favKey(s) + '">Stämmer inte?</button>' +
      '<div class="reportform" hidden><select aria-label="Vad stämmer inte?">' +
      '<option value="finns_ej">Finns inte längre</option>' +
      '<option value="fel_avgift">Fel avgift</option>' +
      '<option value="fel_platser">Fel antal platser</option>' +
      '<option value="fel_laget">Fel läge på kartan</option>' +
      '<option value="annat">Annat</option></select>' +
      '<input type="text" maxlength="255" placeholder="Kommentar (valfritt)" aria-label="Kommentar">' +
      '<button data-act="sendreport">Skicka</button></div>' +
      "</details>" +
      "</div>";
    return html;
  }

  function ltfSectionHtml(s) {
    if (!s.ltf || !s.ltf.length) return "";
    var kindNames = {
      boende: "Boendeparkering", stadning: "Städdag", taxa: "Taxeområde",
      mc: "MC-plats", rorelsehindrad: "Plats för rörelsehindrade"
    };

    // Flera gatusegment kan höra till exakt samma beslut (samma
    // regel gäller en hel sträcka, uppdelad i flera LineString-bitar i
    // källdatan - se README v42) och skiljer sig ofta ENDAST i vilken
    // veckodag just det segmentet städas, medan taxan/villkoren är
    // identiska. Dedupliceringsnyckeln bortser därför från "Städning
    // ..."-delen av texten, så två sådana poster räknas som samma regel
    // istället för att visas som två skilda rader.
    var seen = {};
    var unique = s.ltf.filter(function (z) {
      var infoWithoutCleaning = (z.info || "").replace(/\s*·\s*Städning[^·]*/i, "");
      var key = z.kind + "|" + infoWithoutCleaning;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    var html = '<div class="ltfbox"><div class="paytitle">Gäller på den här platsen</div>';
    unique.slice(0, 3).forEach(function (z) {
      html += '<div class="ltfrow"><strong>' + esc(kindNames[z.kind] || z.kind) + "</strong>" +
        (z.info ? ": " + esc(z.info) : "") + "</div>";
    });
    html += "</div>";
    return html;
  }

  /* ================= Jämför sida vid sida =================
     Max 3 platser åt gången - all data finns redan klientsidan i
     allSpots, så det här är rent presentationsarbete, ingen ny
     backend-endpoint behövs. */
  var compareKeys = [];
  var compareBtn = document.getElementById("compareBtn");
  function updateCompareBtn() {
    if (compareKeys.length === 0) {
      compareBtn.hidden = true;
      return;
    }
    compareBtn.hidden = false;
    document.getElementById("compareBtnLabel").textContent = "Jämför (" + compareKeys.length + ")";
  }
  function renderCompareModal() {
    var spots = compareKeys.map(function (k) {
      return allSpots.find(function (s) { return favKey(s) === k; });
    }).filter(Boolean);
    if (!spots.length) return;

    var ref = destination || (function () { var c = map.getCenter(); return { lat: c.lat, lon: c.lng }; })();
    var rows = [
      { label: "Namn", get: function (s) { return s.name || "Parkering"; } },
      { label: "Typ", get: function (s) { return s.cat && s.cat.garage ? "P-hus" : "Övrigt"; } },
      { label: "Avgift", get: function (s) {
          return s.cat && s.cat.pay === "free" ? "Gratis" : s.cat && s.cat.pay === "paid" ? "Avgift" : "Okänd";
        } },
      { label: "Avstånd", get: function (s) {
          var dm = Math.round(haversine(s.lat, s.lon, ref.lat, ref.lon));
          return dm + " m (~" + walkMinutes(dm) + " min gång)";
        } },
      { label: "Platser", get: function (s) { return s.capacity || "Okänt"; } },
    ];

    var html = '<table class="comparetable"><tr><th></th>' +
      spots.map(function (s) { return "<th>" + esc(s.name || "Parkering") + "</th>"; }).join("") + "</tr>";
    rows.slice(1).forEach(function (r) {
      html += "<tr><td>" + r.label + "</td>" +
        spots.map(function (s) { return "<td>" + esc(String(r.get(s))) + "</td>"; }).join("") + "</tr>";
    });
    html += "</table>";
    document.getElementById("compareBody").innerHTML = html;
    document.getElementById("compareModal").hidden = false;
  }
  document.getElementById("compareBtn").addEventListener("click", renderCompareModal);
  document.getElementById("compareClose").addEventListener("click", function () {
    document.getElementById("compareModal").hidden = true;
  });
  document.getElementById("compareClearAll").addEventListener("click", function () {
    compareKeys = [];
    updateCompareBtn();
    document.getElementById("compareModal").hidden = true;
  });

  document.addEventListener("click", function (e) {
    var parkHereBtn = e.target.closest('[data-act="parkhere"]');
    if (parkHereBtn) {
      saveRemembered({
        lat: parseFloat(parkHereBtn.dataset.lat),
        lon: parseFloat(parkHereBtn.dataset.lon),
        at: Date.now(),
        note: parkHereBtn.dataset.name || null
      });
      renderRemembered();
      showStatus("Sparat! Du hittar tillbaka via knappen \"Minns platsen\".");
      map.closePopup();
      return;
    }
    var compareBtnEl = e.target.closest('[data-act="compare"]');
    if (compareBtnEl) {
      var k = compareBtnEl.dataset.k;
      var idx = compareKeys.indexOf(k);
      if (idx !== -1) {
        compareKeys.splice(idx, 1);
        compareBtnEl.textContent = "Jämför";
      } else {
        if (compareKeys.length >= 3) {
          showStatus("Max 3 platser åt gången – ta bort en först.");
          return;
        }
        compareKeys.push(k);
        compareBtnEl.textContent = "Vald ✓";
      }
      updateCompareBtn();
      return;
    }
    var shareBtn = e.target.closest('[data-act="share"]');
    if (shareBtn) {
      var url = location.origin + location.pathname + "?p=" + shareBtn.dataset.k +
        "&lat=" + map.getCenter().lat.toFixed(5) + "&lng=" + map.getCenter().lng.toFixed(5);
      if (navigator.share) {
        navigator.share({ title: "Parkering", url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { showStatus("Länk kopierad!"); });
      } else {
        showStatus(url);
      }
      return;
    }
    var reportBtn = e.target.closest('[data-act="report"]');
    if (reportBtn) {
      var form = reportBtn.closest(".pp").querySelector(".reportform");
      form.hidden = !form.hidden;
      form.dataset.k = reportBtn.dataset.k;
      return;
    }
    var sendReport = e.target.closest('[data-act="sendreport"]');
    if (sendReport) {
      var rform = sendReport.closest(".reportform");
      var rkey = rform.dataset.k.split("/");
      api("report.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          osm_type: rkey[0], osm_id: +rkey[1],
          reason: rform.querySelector("select").value,
          comment: rform.querySelector("input").value.trim() || null
        })
      }).then(function (d) { showStatus(d.message || "Tack!"); rform.hidden = true; })
        .catch(function (err) { showStatus(err.message); });
    }
  });

  // "Brukar vara ledigt/fullt" – hämtas när popupen med beläggning öppnas
  map.on("popupopen", function (e) {
    var el = e.popup.getElement();
    var occBox = el && el.querySelector("[data-occ-hist]");
    if (!occBox) return;
    var parts = occBox.dataset.occHist.split("/");
    if (!parts[0] || !parts[1]) return;
    api("history.php?source=" + encodeURIComponent(parts[0]) + "&external_id=" + encodeURIComponent(parts[1]))
      .then(function (d) {
        if (!d.typical) return;
        var pct = Math.round(d.typical.avg_free_ratio * 100);
        var span = occBox.querySelector(".occtypical");
        if (span) span.textContent = "Brukar vara " + pct + "% ledigt vid den här tiden";
      }).catch(function () {});
  });

  /* Community-betyg. Låg tidigare i en egen popupopen-hanterare; nu en
     namngiven funktion som toggle-hanteraren för <details class="ppcontrib">
     anropar när sektionen faktiskt fälls ut. Sammanfattningen använder
     ordetiketter i stället för emoji (💡/🛡️/🪧 sa i praktiken ingenting
     utan förklaring, och renderades dessutom olika per plattform). */
  function loadRatings(box) {
    if (!box) return;
    var form = box.querySelector(".ratingform");
    if (!form) return;
    var osmType = form.dataset.osmType, osmId = form.dataset.osmId;

    api("ratings.php?osm_type=" + encodeURIComponent(osmType) + "&osm_id=" + encodeURIComponent(osmId))
      .then(function (d) {
        var summary = box.querySelector(".ratingsummary");
        if (!d.aggregate) { summary.textContent = "Inga betyg ännu – bli först!"; return; }
        var a = d.aggregate, parts = [];
        if (a.lighting_pct !== null) parts.push("Belysning " + a.lighting_pct + "%");
        if (a.safe_pct !== null) parts.push("Trygghet " + a.safe_pct + "%");
        if (a.signage_pct !== null) parts.push("Skyltning " + a.signage_pct + "%");
        summary.textContent = parts.join(" · ") + " (" + a.votes + (a.votes === 1 ? " röst" : " röster") + ")";
      }).catch(function () {
        var sum = box.querySelector(".ratingsummary");
        if (sum) sum.textContent = "";
      });

    // Tre-lägesknappar: – (ej svarat) -> ✓ -> ✗ -> – ...
    form.querySelectorAll("button[data-q]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = { "": "1", "1": "0", "0": "" }[btn.dataset.v];
        btn.dataset.v = next;
        btn.textContent = next === "1" ? "✓" : next === "0" ? "✗" : "–";
        btn.className = next === "1" ? "yes" : next === "0" ? "no" : "";
      });
    });
    form.querySelector(".ratingsubmit").addEventListener("click", function () {
      var body = { osm_type: osmType, osm_id: +osmId };
      form.querySelectorAll("button[data-q]").forEach(function (btn) {
        body[btn.dataset.q] = btn.dataset.v === "" ? null : btn.dataset.v === "1";
      });
      if (body.lighting_good === null && body.feels_safe === null && body.signage_accurate === null) {
        showStatus("Svara på minst en fråga först.");
        return;
      }
      api("ratings.php", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body)
      }).then(function (d) { showStatus(d.message || "Tack!"); })
        .catch(function (err) { showStatus(err.message); });
    });
  }

  function chargerPopupHtml(s) {
    var t = s.tags || {};
    var html = '<div class="pp"><div class="pphead"><h3>' +
      esc(s.name || "Laddstation") + '</h3></div><span class="tag tag--charging">Laddstation</span>';
    if (s.fee === "no") html += '<span class="tag tag--free">Gratis</span>';
    if (s.fee === "yes") html += '<span class="tag tag--paid">Avgift</span>';
    html += nowBadges({ tags: t, fee: s.fee });
    html += "<table>";
    if (s.sockets) html += "<tr><td>Uttag</td><td>" + s.sockets + "</td></tr>";
    if (s.max_kw) html += "<tr><td>Max effekt</td><td>" + s.max_kw + " kW</td></tr>";
    var socketTypes = [];
    for (var key in t) {
      var sm = key.match(/^socket:([a-z0-9_]+)$/);
      if (sm) socketTypes.push(sm[1].replace(/_/g, " "));
    }
    if (socketTypes.length) html += "<tr><td>Kontakter</td><td>" + esc(socketTypes.join(", ")) + "</td></tr>";
    if (s.operator) html += "<tr><td>Operatör</td><td>" + esc(s.operator) + "</td></tr>";
    if (t.network && t.network !== s.operator) html += "<tr><td>Nätverk</td><td>" + esc(t.network) + "</td></tr>";
    if (t.opening_hours) html += "<tr><td>Öppet</td><td>" + esc(t.opening_hours) + "</td></tr>";

    var authMethods = [];
    var authLabels = {
      app: "app", membership_card: "medlemskort", nfc: "nfc/kontaktlöst",
      phone_call: "telefonsamtal", short_message: "sms", none: "inget krävs"
    };
    for (var akey in authLabels) {
      if (t["authentication:" + akey] === "yes") authMethods.push(authLabels[akey]);
    }
    if (authMethods.length) html += "<tr><td>Starta med</td><td>" + esc(authMethods.join(", ")) + "</td></tr>";

    var paymentMethods = [];
    var paymentLabels = { app: "app", contactless: "kontaktlöst", credit_cards: "kort", cash: "kontant" };
    for (var pkey in paymentLabels) {
      if (t["payment:" + pkey] === "yes") paymentMethods.push(paymentLabels[pkey]);
    }
    if (paymentMethods.length) html += "<tr><td>Betalning</td><td>" + esc(paymentMethods.join(", ")) + "</td></tr>";

    html += "</table>";
    html += '<div style="margin-top:7px">' + directionLinksHtml(s.lat, s.lon) + '</div></div>';
    return html;
  }

  /* ---- Prisruta: hämtas när popupen öppnas ---- */
  function priceSparkline(history) {
    var w = 220, h = 40, pad = 4;
    var values = history.map(function (h) { return h.median; });
    var min = Math.min.apply(null, values), max = Math.max.apply(null, values);
    var range = max - min || 1;
    var stepX = (w - pad * 2) / (values.length - 1);

    var points = values.map(function (v, i) {
      var x = pad + i * stepX;
      var y = h - pad - ((v - min) / range) * (h - pad * 2);
      return x.toFixed(1) + "," + y.toFixed(1);
    }).join(" ");

    var last = history[history.length - 1];
    return '<div class="sparkwrap"><svg viewBox="0 0 ' + w + " " + h + '" class="spark" ' +
      'role="img" aria-label="Prisutveckling senaste månaderna">' +
      '<polyline points="' + points + '" fill="none" stroke="#0D5EAF" stroke-width="2"/>' +
      "</svg><small>Prisutveckling " + history.length + " mån, senast " + last.median + " kr/tim</small></div>";
  }

  function loadPrices(container) {
    var key = container.dataset.priceFor.split("/");
    api("prices.php?osm_type=" + key[0] + "&osm_id=" + key[1])
      .then(function (d) {
        var html = "";
        if (d.median != null) {
          html += 'Rapporterat pris: <span class="median">' + d.median +
            " kr/tim</span> <small>(" + d.count + " rapporter)</small>";
        } else if (d.pending > 0) {
          html += "En rapport väntar på granskning.";
        } else {
          html += "Inga prisrapporter ännu.";
        }
        if (d.history && d.history.length >= 2) html += priceSparkline(d.history);
        html += '<br><button class="pricebtn" data-act="showform">Rapportera pris</button>' +
          '<div class="priceform" hidden>' +
          '<input type="number" min="0" max="500" step="0.5" placeholder="kr/tim" aria-label="Pris kr per timme">' +
          '<input type="text" maxlength="255" placeholder="Kommentar (valfritt)" aria-label="Kommentar">' +
          '<button data-act="send">Skicka</button></div>';
        container.innerHTML = html;
      })
      .catch(function () { container.textContent = ""; });
  }

  /* Pris- och betygssammanfattningarna ligger numera bakom <details
     class="ppcontrib">. Att hämta dem vid popupopen skulle innebära två
     API-anrop per öppnad parkering för innehåll som är dolt – de hämtas
     därför när sektionen fälls ut, en gång per popup. */
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains("ppcontrib") || !d.open) return;
    if (d.dataset.loaded === "1") return;
    d.dataset.loaded = "1";
    var priceBox = d.querySelector("[data-price-for]");
    if (priceBox) loadPrices(priceBox);
    var ratingBox = d.querySelector("[data-rating-for]");
    if (ratingBox && typeof loadRatings === "function") loadRatings(ratingBox);
  }, true);

  document.addEventListener("click", function (e) {
    var showBtn = e.target.closest('.pricebtn[data-act="showform"]');
    if (showBtn) {
      var form = showBtn.parentElement.querySelector(".priceform");
      form.hidden = !form.hidden;
      return;
    }
    var sendBtn = e.target.closest('.priceform button[data-act="send"]');
    if (sendBtn) {
      var box = sendBtn.closest("[data-price-for]");
      var key = box.dataset.priceFor.split("/");
      var price = parseFloat(box.querySelector('input[type="number"]').value);
      var comment = box.querySelector('input[type="text"]').value.trim();
      if (isNaN(price)) { showStatus("Ange ett pris i kr/tim."); return; }
      api("prices.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          osm_type: key[0], osm_id: +key[1],
          price_per_hour: price, comment: comment || null
        })
      }).then(function (d) {
        showStatus(d.message || "Tack för din prisrapport!");
        loadPrices(box);
      }).catch(function (err) { showStatus(err.message); });
    }
  });

  /* ---- Stjärnklick ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".pp .star");
    if (!btn) return;
    var key = btn.dataset.k.split("/");
    var isOn = btn.classList.contains("on");
    api("favorites.php", {
      method: isOn ? "DELETE" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ osm_type: key[0], osm_id: +key[1] })
    }).then(function () {
      btn.classList.toggle("on");
      if (isOn) delete favorites[btn.dataset.k];
      else favorites[btn.dataset.k] = true;
      loadFavorites();
      showStatus(isOn ? "Borttagen från favoriter." : "Sparad som favorit.");
    }).catch(function (err) { showStatus("Kunde inte spara: " + err.message); });
  });

  /* ================= Rendering ================= */
  var markerByKey = {};
  var zoneMarkerByCode = {};

  function render() {
    layer.clearLayers();
    markerByKey = {};
    var shown = 0;
    allSpots.forEach(function (s) {
      if (!matchesFilter(s)) return;
      shown++;
      var icon = L.divIcon({
        className: "",
        html: '<div class="pmarker" style="background:' + markerColor(s.cat) + '">' + markerLetter(s.cat) + '</div>',
        iconSize: [26, 26], iconAnchor: [13, 13], popupAnchor: [0, -12]
      });
      var mk = L.marker([s.lat, s.lon], { icon: icon })
        .bindPopup(function () { return popupHtml(s); })
        .addTo(layer);
      markerByKey[favKey(s)] = mk;
    });
    renderList();
    return shown;
  }

  function renderChargers(items) {
    chargerLayer.clearLayers();
    items.forEach(function (s) {
      var icon = L.divIcon({
        className: "",
        html: '<div class="cmarker">' + icon("zap", 14) + "</div>",
        iconSize: [24, 24], iconAnchor: [12, 12], popupAnchor: [0, -12]
      });
      L.marker([s.lat, s.lon], { icon: icon })
        .bindPopup(function () { return chargerPopupHtml(s); })
        .addTo(chargerLayer);
    });
  }

  function renderBicycles(items) {
    bicycleLayer.clearLayers();
    items.forEach(function (s) {
      var icon = L.divIcon({
        className: "",
        html: '<div class="bmarker">' + icon("bike", 14) + "</div>",
        iconSize: [24, 24], iconAnchor: [12, 12], popupAnchor: [0, -12]
      });
      L.marker([s.lat, s.lon], { icon: icon })
        .bindPopup(function () { return bicyclePopupHtml(s); })
        .addTo(bicycleLayer);
    });
  }

  function bicyclePopupHtml(s) {
    var bikeTypeNames = { stands: "Cykelställ", wall_loops: "Cykelbygel", lockers: "Cykelbox", shed: "Cykelskjul" };
    var html = '<div class="pp"><div class="pphead"><h3>' + esc(s.name || "Cykelparkering") +
      '</h3></div><span class="tag tag--bicycle">Cykelparkering</span>';
    if (s.covered) html += '<span class="tag" style="background:#5A5A8F">Väderskyddad</span>';
    html += "<table>";
    if (s.capacity) html += "<tr><td>Platser</td><td>" + s.capacity + "</td></tr>";
    if (bikeTypeNames[s.bike_type]) html += "<tr><td>Typ</td><td>" + bikeTypeNames[s.bike_type] + "</td></tr>";
    html += "</table>";
    html += '<div style="margin-top:7px">' + directionLinksHtml(s.lat, s.lon) + "</div></div>";
    return html;
  }

  /* ---- Fristående betalzon-markörer -----------------------------------
     Gatuparkering med zonkod har oftast ingen egen punkt i OpenStreetMap –
     zonen gäller ett gatuavsnitt, inte en enskild parkering. Zoner måste
     därför synas som egna markörer, inte bara dyka upp i en befintlig
     parkerings popup. Zoner som ligger inom 25 m av varandra grupperas till
     en markör (flera betaltjänster på samma fysiska plats). ------------- */
  function renderPayZones(items) {
    zoneLayer.clearLayers();
    zoneMarkerByCode = {};
    var groups = [];
    items.forEach(function (z) {
      var g = groups.find(function (g) { return haversine(g.lat, g.lon, z.lat, z.lon) <= 25; });
      if (g) g.zones.push(z);
      else groups.push({ lat: z.lat, lon: z.lon, zones: [z] });
    });

    groups.forEach(function (g) {
      var icon = L.divIcon({
        className: "",
        html: '<div class="zmarker">' + esc(g.zones[0].zone_code) + '</div>',
        iconSize: [40, 24], iconAnchor: [20, 12], popupAnchor: [0, -12]
      });
      var mk = L.marker([g.lat, g.lon], { icon: icon, zIndexOffset: 500 })
        .bindPopup(function () { return zonePopupHtml(g.zones); })
        .addTo(zoneLayer);
      // Alla zonkoder i en grupp pekar mot samma markör, så en QR-länk
      // för VILKEN som helst av flera samlokaliserade betaltjänster på
      // samma fysiska plats öppnar rätt popup.
      g.zones.forEach(function (z) { zoneMarkerByCode[z.zone_code] = mk; });
    });
  }

  /* ---- Reserverade handikapp-p-platser (från LTF-datan, kind=taxa med
     vehicle_type=rörelsehindrade) --------------------------------------
     Fanns tidigare bara gömda i en popup om de råkade ligga inom 60 m av
     en redan känd parkering från OSM - många dedikerade gatuplatser för
     rörelsehindrade ligger inte alls nära någon OSM-spårad parkering och
     var därför praktiskt taget osynliga. Egna markörer + eget filter
     löser det, samma mönster som betalzonerna ovan. */

  /* ================= Rutnätsindex för LTF-zoner =================
     Matchningen "vilka föreskrifter gäller den här parkeringen" var
     O(parkeringar × zoner): för VARJE parkering loopades ALLA zoner med ett
     haversine-anrop per par. I Stockholms innerstad är det hundratals
     parkeringar mot tusentals zoner – hundratusentals trigonometrianrop på
     huvudtråden, vid varje kartrörelse som utlöser en hämtning. Symptomet
     var att kartan hakade upp sig just där appen är som mest användbar.

     Zonerna läggs nu i ett rutnät med ~0.001° celler (≈110 m i nord-sydlig
     led, ≈55 m i öst-västlig på Stockholms latitud – alltså alltid större än
     sökradien på 20 m). Bara den egna cellen och dess åtta grannar behöver
     testas, vilket gör kostnaden proportionell mot antalet parkeringar i
     stället för produkten.

     0.001° är medvetet grovt: mindre celler ger fler tomma uppslag utan att
     minska antalet verkliga kandidater nämnvärt, eftersom LTF-segment ligger
     tätt längs gator. */
  var LTF_CELL = 0.001;

  function ltfCellKey(lat, lon) {
    return Math.floor(lat / LTF_CELL) + ":" + Math.floor(lon / LTF_CELL);
  }

  function buildLtfIndex(zones) {
    var index = {};
    zones.forEach(function (z) {
      var key = ltfCellKey(z.lat, z.lon);
      (index[key] || (index[key] = [])).push(z);
    });
    return index;
  }

  /* Zoner inom radiusM av en punkt, sorterade på avstånd. Samma resultat som
     den gamla helsvepningen – bara utan att röra zoner som omöjligt kan vara
     nära nog. */
  function ltfNear(index, lat, lon, radiusM) {
    var baseLat = Math.floor(lat / LTF_CELL), baseLon = Math.floor(lon / LTF_CELL);
    var hits = [];
    for (var dLat = -1; dLat <= 1; dLat++) {
      for (var dLon = -1; dLon <= 1; dLon++) {
        var cell = index[(baseLat + dLat) + ":" + (baseLon + dLon)];
        if (!cell) continue;
        for (var i = 0; i < cell.length; i++) {
          var d = haversine(lat, lon, cell[i].lat, cell[i].lon);
          if (d <= radiusM) hits.push({ z: cell[i], d: d });
        }
      }
    }
    hits.sort(function (a, b) { return a.d - b.d; });
    return hits.map(function (h) { return h.z; });
  }

  /* ================= Taxefärgad karta =================
     Kartan visade tidigare taxeområden som lösa punktmarkörer: informationen
     fanns, men man kunde inte SE att man kört från en 20-kronorsgata in på
     en 55-kronorsgata – man fick klicka sig fram, en punkt i taget. Nu
     färgläggs själva gatusträckorna, vilket är hela poängen med att datan är
     linjer och inte punkter.

     Geometrin kommer från ltf_zones.line (v49) och ritas bara för poster som
     faktiskt har ett taxenummer. Poster utan geometri – äldre rader som
     synkades innan kolumnen fanns – hoppas tyst över här och fortsätter
     visas som markörer, så en halvsynkad databas ser ofullständig ut men
     aldrig trasig. */
  var tariffLinesVisible = false;

  function renderTariffLines(zones) {
    tariffLayer.clearLayers();
    if (!tariffLinesVisible) return;

    var drawn = 0;
    zones.forEach(function (z) {
      if (!z.taxa || !z.line || z.line.length < 2) return;
      var tariff = STOCKHOLM_TARIFFS[z.taxa];
      if (!tariff) return;

      /* Två linjer ovanpå varandra: en bred, nästan genomskinlig "halo"
         under den färgade. Utan den försvinner en 4px linje i mörkt läge
         mot den mörka kartan, och i ljust läge mot ljusa gator – kartan
         under är inte en kontrollerad bakgrund, den byter utseende med
         både tema och zoomnivå. */
      L.polyline(z.line, {
        color: tariff.color, weight: 9, opacity: 0.18, lineCap: "round", interactive: false
      }).addTo(tariffLayer);

      var line = L.polyline(z.line, {
        color: tariff.color, weight: 4, opacity: 0.95, lineCap: "round"
      });
      line.bindPopup(function () { return tariffPopupHtml(z); });
      line.addTo(tariffLayer);
      drawn++;
    });
    return drawn;
  }

  /* Popup för en taxefärgad gatusträcka. Samma prisuträkning som i
     parkeringspopupen – en enda funktion, så en gata och en parkering på
     samma gata omöjligen kan visa olika pris för samma tidpunkt. */
  function tariffPopupHtml(z) {
    var tariff = STOCKHOLM_TARIFFS[z.taxa];
    var now = tariffPriceNow(z.taxa);
    return '<div class="pp">' +
      '<div class="pphead">' +
      '<span class="pptype" style="background:' + tariff.color + '">' + icon("psign", 20) + "</span>" +
      '<div class="pptitle"><small>Taxeområde</small><h3>' +
      esc(z.name || "Gatuparkering") + "</h3></div></div>" +
      '<span class="tag tag--taxa" style="background:' + tariff.color + '">Taxa ' + z.taxa + "</span>" +
      '<div class="ppnow' + (now.free ? " is-free" : "") + '"><strong>' + esc(now.label) + "</strong>" +
      "<small>Ordinarie " + esc(tariff.price) + "</small></div>" +
      '<p class="pptariffhours">' + esc(tariff.hours) + "</p>" +
      (z.info ? '<div class="ltfbox"><div class="ltfrow">' + esc(z.info) + "</div></div>" : "") +
      '<p class="ppdisclaimer">Skyltningen på gatan gäller alltid före den här uppgiften.</p>' +
      '<div class="ppfoot">' + directionLinksHtml(z.lat, z.lon) +
      (z.citation_url ? '<a class="linkbtn" href="' + esc(z.citation_url) +
        '" target="_blank" rel="noopener">Se beslutet</a>' : "") +
      "</div></div>";
  }

  /* Teckenförklaring. Utan den är fem färger bara fem färger – man kan se
     ATT gatorna skiljer sig åt, men inte vilken som är dyrast. Priserna som
     visas är de som gäller just nu, inte ordinarietaxan, av samma skäl som
     popupen: det är den siffra man faktiskt jämför på. */
  /* Geometrin ligger i ett EGET anrop, inte i parkings.php.
     parkings.php körs vid varje kartrörelse, medan taxelagret är avstängt
     som standard – att skicka med koordinaterna där innebar att i stort sett
     alla användare laddade ned geometri som aldrig ritades (v49:s misstag,
     rättat i v50). Svaret cachas per position så att en av- och påslagning
     inte ger ett nytt anrop. */
  var tariffGeometryCache = { key: null, zones: [] };
  function loadTariffGeometry() {
    var c = map.getCenter();
    var key = c.lat.toFixed(3) + "," + c.lng.toFixed(3) + "," + currentRadius();
    if (tariffGeometryCache.key === key) {
      reportTariffLines(renderTariffLines(tariffGeometryCache.zones));
      return;
    }
    showStatus("Hämtar taxeområden…", true);
    api("ltf.php?geometry=1&lat=" + c.lat.toFixed(6) + "&lng=" + c.lng.toFixed(6) +
        "&radius=" + currentRadius())
      .then(function (d) {
        tariffGeometryCache = { key: key, zones: d.zones || [] };
        reportTariffLines(renderTariffLines(tariffGeometryCache.zones));
      })
      .catch(function (err) {
        showStatus("Kunde inte hämta taxeområden: " + err.message);
      });
  }

  function reportTariffLines(drawn) {
    if (drawn) {
      showStatus("Visar " + drawn + " taxefärgade gatusträckor.");
      return;
    }
    // Ärligt besked i stället för en tom karta: taxefärgning finns bara där
    // LTF-data hämtats, dvs. Stockholm, och bara för rader som synkats efter
    // v49 (då geometrin började sparas).
    showStatus(tariffGeometryCache.zones.length
      ? "Ingen taxegeometri här ännu – kör om LTF-synken, eller prova innerstaden."
      : "Taxeområden finns bara i Stockholm. Sök där först.");
  }

  function renderTariffLegend() {
    var el = document.getElementById("tariffLegend");
    if (!el) return;
    if (!tariffLinesVisible) { el.hidden = true; return; }
    var rows = [1, 2, 3, 4, 5].map(function (n) {
      var now = tariffPriceNow(n);
      return '<div class="legendrow"><span class="legendswatch" style="background:' +
        STOCKHOLM_TARIFFS[n].color + '"></span>' +
        "<strong>Taxa " + n + "</strong><span>" +
        esc(now.free ? "Avgiftsfritt" : now.amount + " kr/tim") + "</span></div>";
    }).join("");
    el.innerHTML = '<div class="legendhead">Taxa just nu</div>' + rows;
    el.hidden = false;
  }

  function renderDisabledParking(ltfZones) {
    disabledLayer.clearLayers();
    ltfZones
      /* Två källor till samma sak: den dedikerade prorelsehindrad-
         föreskriften (kind "rorelsehindrad", ny i v48) och den äldre
         härledningen ur VEHICLE-fältet i ptillaten. Båda accepteras –
         den gamla vägen slutar alltså inte fungera för data som redan
         ligger i databasen och ännu inte hunnit synkas om. */
      .filter(function (z) {
        return z.kind === "rorelsehindrad" || z.vehicle_type === "rörelsehindrade";
      })
      .forEach(function (z) {
        var markerIcon = L.divIcon({
          className: "", html: '<div class="disabledmarker">' + icon("access", 15) + "</div>",
          iconSize: [26, 26], iconAnchor: [13, 13], popupAnchor: [0, -12]
        });
        L.marker([z.lat, z.lon], { icon: markerIcon, zIndexOffset: 600 })
          .bindPopup(
            '<div class="pp"><h3>' + esc(z.name || "Handikapparkering") +
      '</h3><span class="tag tag--disabled">Handikapparkering</span>' +
            (z.info ? '<p style="font-size:13px;color:var(--gray);margin-top:4px">' + esc(z.info) + "</p>" : "") +
            (z.length_m ? '<p style="font-size:12px;color:var(--gray);margin-top:2px">Platsens längd: ' + z.length_m + ' m</p>' : "") +
            '<div class="ppfoot">' + directionLinksHtml(z.lat, z.lon) +
            (z.citation_url ? '<a class="linkbtn" href="' + esc(z.citation_url) + '" target="_blank" rel="noopener">Se beslutet</a>' : "") +
            "</div></div>"
          )
          .addTo(disabledLayer);
      });
  }

  function zonePopupHtml(zones) {
    var html = '<div class="pp"><div class="paybox" style="margin:0;border:0;padding:0">' +
      '<div class="paytitle">Betala parkeringen</div>';
    zones.forEach(function (z) { html += payZoneRow(z); });
    html += '<div class="platerow">Reg.nr: <input type="text" class="plateinput" maxlength="7" ' +
      'placeholder="ABC123" value="' + esc(getPlate()) + '"> <small>sparas bara i din webbläsare</small></div>';
    html += '<small class="paynote">Kontrollera alltid att zonkoden stämmer med skylten på platsen.</small>';
    html += "</div></div>";
    return html;
  }

  /* ---- Listpanel: sorterad på gå-tid till målet (eller kartcentrum) ---- */
  function renderList() {
    var ref = destination || (function () {
      var c = map.getCenter(); return { lat: c.lat, lon: c.lng, name: null };
    })();
    document.getElementById("listTitle").textContent =
      destination ? "Närmast " + (destination.name || "målet") : "Närmast kartans mitt";

    var items = allSpots.filter(matchesFilter).map(function (s) {
      return { s: s, d: haversine(s.lat, s.lon, ref.lat, ref.lon) };
    }).sort(function (a, b) { return a.d - b.d; }).slice(0, 30);

    listBody.innerHTML = "";
    if (!items.length) {
      listBody.innerHTML = '<p class="favempty">Inga parkeringar att visa. Tryck på ”Sök här” först.</p>';
      return;
    }
    items.forEach(function (it) {
      var s = it.s;
      var b = document.createElement("button");
      b.className = "listitem";
      var payText = s.cat.pay === "free" ? "Gratis" : s.cat.pay === "paid" ? "Avgift" : "Okänd taxa";
      b.innerHTML =
        '<span class="lmark" style="background:' + markerColor(s.cat) + '">' + markerLetter(s.cat) + '</span>' +
        '<span class="ltext"><strong>' + esc(s.name || (s.cat.garage ? "Parkeringshus" : "Parkering")) +
        "</strong><small>" + payText + (s.capacity ? " · " + s.capacity + " platser" : "") + "</small></span>" +
        '<span class="lwalk">' + walkMinutes(it.d) + " min<small>" + Math.round(it.d) + " m</small></span>";
      b.addEventListener("click", function () {
        map.setView([s.lat, s.lon], Math.max(map.getZoom(), 17));
        var mk = markerByKey[favKey(s)];
        if (mk) mk.openPopup();
      });
      listBody.appendChild(b);
    });
  }

  document.getElementById("listBtn").addEventListener("click", function () {
    listPanel.hidden = !listPanel.hidden;
    if (!listPanel.hidden) renderList();
  });
  document.getElementById("listClose").addEventListener("click", function () {
    listPanel.hidden = true;
  });

  /* ================= Datahämtning ================= */
  function currentRadius() {
    var z = map.getZoom();
    return z >= 16 ? 700 : z >= 14 ? 1300 : 2500;
  }

  /* ================= Väderanpassat råd ================= */
  var weatherBanner = document.getElementById("weatherBanner");
  var lastWeatherCheck = 0;
  function fetchWeatherAdvice(lat, lng) {
    var now = Date.now();
    if (now - lastWeatherCheck < 15 * 60 * 1000) return; // max var 15:e minut
    lastWeatherCheck = now;
    api("weather_advice.php?lat=" + lat.toFixed(4) + "&lng=" + lng.toFixed(4))
      .then(function (d) {
        if (d.advice && d.advice.prefer_covered) {
          weatherBanner.textContent = d.advice.reason + " – väderskyddad parkering (p-hus) kan vara skönare.";
          weatherBanner.hidden = false;
        } else {
          weatherBanner.hidden = true;
        }
      }).catch(function () { /* tyst – vädret är en bonus, inte kritiskt */ });
  }
  document.getElementById("weatherBanner").addEventListener("click", function () {
    weatherBanner.hidden = true;
  });

  /* ================= Språk (sv/en) =================
     Medvetet begränsad omfattning: täcker den mest synliga STATISKA
     texten (header, filterchips, knappar, onboarding) – inte allt
     dynamiskt innehåll (popup-text, admin-panelen, API-felmeddelanden).
     En fullständig översättning av hela appen är ett mycket större
     jobb än vad som rymdes här; det här ger internationella besökare
     ett begripligt gränssnitt utan att låtsas vara mer komplett än det
     faktiskt är. */
  var TRANSLATIONS = {
    en: {
      tagline: "Parking, garages, charging stations and park & ride",
      navAbout: "About", navStats: "Statistics", navSuggest: "Suggest a zone code", navBusiness: "Business",
      searchPlaceholder: "Search address or city in Sweden…", search: "Search",
      filterAll: "All", filterFree: "Free", filterPaid: "Paid", filterGarage: "Garage",
      filterOpenNow: "Open now", filterParkRide: "Park & ride",
      filterChargers: "Charging", filterBicycle: "Bicycle parking",
      filterMc: "Motorcycle", filterMotorhome: "Motorhome", filterDisabled: "Accessible parking",
      filterMore: "More filters", moreFiltersHead: "More filters",
      filterTariff: "Tariff zones",
      saveOffline: "Save offline", settings: "Settings",
      listBtn: "List", searchHere: "Search here",
      onboardingSkip: "Skip",
      citiesTitle: "Where do you want to park?",
      citiesSubtitle: "Pick a city, search an address, or use your location.",
      useMyLocation: "Use my location",
      myFavorites: "My favorites",
      noFavoritesYet: "No favorites yet. Open a parking spot on the map and tap the star.",
      loginToSync: "Log in to sync favorites across your devices.",
      sendLink: "Send link",
      rememberSpot: "Remember spot", paidUntil: "Paid until",
      goBack: "Go back", doneRemove: "Done, remove"
    }
  };
  var ONBOARDING_SLIDES_EN = [
    { title: "Welcome to Parkera i Sverige", body: "A free map of parking, garages, charging stations and park & ride across Sweden – real-time availability wherever the municipality shares that data." },
    { title: "Filter with the chips", body: "Tap \"Free\", \"Paid\", \"Garage\" or any of the other chips at the top to only show what you're looking for." },
    { title: "Remember where you parked", body: "Tap the pin button on the right – or \"Park here\" directly in a spot's popup – to find your way back even in a big garage." },
    { title: "Paid-until timer", body: "Set a timer once you've paid, and we'll remind you (if notifications are enabled) before it runs out." },
    { title: "Help others find the right info", body: "See something wrong on the map, or a missing zone code? Tap ⚠ in a spot's popup, or \"Suggest a zone code\" in the menu – reviewed before it's shown to others." }
  ];
  function applyLanguage(lang) {
    var dict = TRANSLATIONS[lang];
    document.querySelectorAll("[data-i18n]").forEach(function (el) {
      // Sparar ALLTID den svenska originaltexten första gången ett element
      // ses, INNAN något annat händer - oavsett vilket språk som råkar
      // appliceras först. Tidigare sparades den bara som en reservåtgärd
      // när ingen översättning hittades, vilket gjorde att en session som
      // startade på engelska (t.ex. engelsk webbläsare) ALDRIG fick den
      // svenska originaltexten sparad – växling tillbaka till svenska
      // gjorde då ingenting alls, permanent för resten av sessionen.
      if (!el.hasAttribute("data-i18n-sv")) {
        el.setAttribute("data-i18n-sv", el.textContent);
      }
      if (dict && dict[el.getAttribute("data-i18n")]) {
        el.textContent = dict[el.getAttribute("data-i18n")];
      } else {
        el.textContent = el.getAttribute("data-i18n-sv");
      }
    });
    /* title-attributen (musens tooltip) var hårdkodad svenska och följde
       inte med språkbytet – samma fälla som aria-label hade, och som
       .visually-hidden-spannen löste för det tillgängliga namnet. Återanvänder
       samma nycklar: en knapp som redan har ett data-i18n-spann behöver ingen
       egen nyckel till, bara samma. */
    document.querySelectorAll("[data-i18n-title]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-title");
      if (!el.hasAttribute("data-i18n-title-sv")) {
        el.setAttribute("data-i18n-title-sv", el.getAttribute("title") || "");
      }
      el.title = (dict && dict[key]) || el.getAttribute("data-i18n-title-sv");
    });
    document.querySelectorAll("[data-i18n-placeholder]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-placeholder");
      if (lang === "en" && dict && dict[key]) el.placeholder = dict[key];
      else el.placeholder = "Sök adress eller ort i Sverige…";
    });
    document.documentElement.setAttribute("lang", lang);
    // Skrev tidigare knappens HELA innehåll: textContent = "EN" raderade
    // både ikonen och etikettspannet inuti #langBtn. Bara etiketten ska
    // röras – och den namnger det språk man byter TILL, inte det man har
    // ("English" när gränssnittet är svenskt), eftersom en knapp med texten
    // "Svenska" i ett svenskt gränssnitt inte säger vad den gör.
    langLabel.textContent = lang === "en" ? "Svenska" : "English";
    localStorage.setItem("parkera_lang", lang);
    ONBOARDING_SLIDES = lang === "en" ? ONBOARDING_SLIDES_EN : ONBOARDING_SLIDES_SV;
    if (!onboardingEl.hidden) renderOnboardingSlide();
    // Temaetiketten sätts av syncThemeIcon (beror på läge, inte bara språk).
    if (typeof syncThemeIcon === "function") syncThemeIcon();
  }
  var langBtn = document.getElementById("langBtn");
  var langLabel = document.getElementById("langLabel");
  langBtn.addEventListener("click", function () {
    var current = document.documentElement.getAttribute("lang") === "en" ? "en" : "sv";
    applyLanguage(current === "en" ? "sv" : "en");
  });

  /* ================= Inställningsmenyn =================
     Tema, språk och "Om tjänsten" rör man en gång och sedan aldrig mer. De
     låg tidigare som ensamma ikoner i samma rad som favoriter och
     offline-sparning, dvs. sex likvärdiga knappar där hälften trycktes en
     gång i livet. Nu bakom en egen knapp, med riktiga textetiketter – en
     naken ikon för "byt språk" är en gissningslek när man ändå trycker på
     den så sällan att man aldrig hinner lära sig den. */
  var settingsBtn = document.getElementById("settingsBtn");
  var settingsMenu = document.getElementById("settingsMenu");

  function setSettingsOpen(open) {
    settingsMenu.hidden = !open;
    settingsBtn.setAttribute("aria-expanded", open ? "true" : "false");
  }
  settingsBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    setSettingsOpen(settingsMenu.hidden);
  });

  /* Stäng vid klick utanför och på Escape. En meny som bara går att stänga
     med samma knapp som öppnade den är en fälla på mobil, där man
     instinktivt trycker bredvid. Klick INUTI menyn får inte stänga den för
     tidigt – språkknappen ska hinna köra sin egen hanterare. */
  document.addEventListener("click", function (e) {
    if (settingsMenu.hidden) return;
    if (settingsMenu.contains(e.target) || settingsBtn.contains(e.target)) return;
    setSettingsOpen(false);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !settingsMenu.hidden) {
      setSettingsOpen(false);
      settingsBtn.focus();
    }
  });
  /* Kartan äter inte klick åt oss: ett klick på kartan bubblar inte upp till
     document i Leaflet, så menyn hade blivit kvar öppen ovanpå kartan. */
  map.on("click", function () { if (!settingsMenu.hidden) setSettingsOpen(false); });

  /* ================= Mörkt/ljust läge ================= */
  var themeBtn = document.getElementById("themeBtn");
  var moonIcon = document.getElementById("themeIconMoon");
  var sunIcon = document.getElementById("themeIconSun");

  function currentlyDark() {
    var attr = document.documentElement.getAttribute("data-theme");
    if (attr === "dark") return true;
    if (attr === "light") return false;
    // Inget explicit val sparat än - följer systemets eget val, precis
    // som CSS:en gör via prefers-color-scheme.
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
  var themeLabel = document.getElementById("themeLabel");

  /* Etiketten beskriver vad knappen GÖR, inte vilket läge som råder – står
     det "Mörkt läge" medan appen redan är mörk är det en gissningslek om
     knappen är en växel eller en statusrad. Sätts härifrån och inte via
     data-i18n, eftersom texten beror på både språk OCH nuvarande läge;
     applyLanguage anropar syncThemeIcon() så båda hålls i takt. */
  function syncThemeIcon() {
    var dark = currentlyDark();
    moonIcon.hidden = dark;
    sunIcon.hidden = !dark;
    if (themeLabel) {
      var en = document.documentElement.getAttribute("lang") === "en";
      themeLabel.textContent = dark
        ? (en ? "Light mode" : "Ljust läge")
        : (en ? "Dark mode" : "Mörkt läge");
    }
  }
  themeBtn.addEventListener("click", function () {
    var next = currentlyDark() ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("parkera_theme", next);
    syncThemeIcon();
    updateTileLayerForTheme(next === "dark");
  });
  syncThemeIcon();

  /* ================= Offline-indikator =================
     Appen cachar redan smart för offline-bruk (se sw.js: nätverk-först
     med cache-fallback för appskal och API-svar) - men gav ingen visuell
     signal NÄR man faktiskt är offline, vilket gjorde den osynliga
     infrastrukturen just osynlig. En enkel banderoll baserad på
     online/offline-händelser gör det synligt att det faktiskt fungerar. */
  var offlineBanner = document.getElementById("offlineBanner");
  function updateOfflineBanner() {
    offlineBanner.hidden = navigator.onLine;
  }
  window.addEventListener("online", updateOfflineBanner);
  window.addEventListener("offline", updateOfflineBanner);
  updateOfflineBanner();

  function searchParking() {
    var c = map.getCenter();
    if (map.getZoom() < 12) { showStatus("Zooma in lite närmare – eller sök en ort först."); return; }
    lastFetchCenter = { lat: c.lat, lng: c.lng };

    hereBtn.disabled = true;
    showStatus("Hämtar parkeringar…", true);

    api("parkings.php?lat=" + c.lat.toFixed(6) + "&lng=" + c.lng.toFixed(6) + "&radius=" + currentRadius())
      .then(function (data) {
        var ltfZones = data.ltf_zones || [];
        var ltfIndex = buildLtfIndex(ltfZones);
        allSpots = (data.elements || []).map(function (s) {
          s.cat = categorize(s);
          if (ltfZones.length) {
            // 20 m, inte 60 m som tidigare - LTF-data är uppdelad per
            // gatusegment (se README v42/v47), och 60 m fångade lätt in
            // regler för en annan närliggande gata/parkering, inte bara
            // det som faktiskt gäller just den här platsen. Sorterat på
            // avstånd så den mest relevanta träffen (om flera) listas
            // först i popupen.
            s.ltf = ltfNear(ltfIndex, s.lat, s.lon, 20);
          }
          return s;
        });
        var shown = render();
        renderPayZones(data.pay_zones || []);
        lastLtfZones = data.ltf_zones || [];
        renderDisabledParking(lastLtfZones);
        // Taxelinjerna ritas INTE härifrån: de har sin egen, geometribärande
        // hämtning (loadTariffGeometry) som bara körs när lagret är påslaget.
        if (tariffLinesVisible) loadTariffGeometry();
        hereBtn.disabled = false;
        if (!allSpots.length) showStatus("Inga parkeringar hittades i området. Prova att flytta kartan.");
        else showStatus(shown + " av " + allSpots.length + " parkeringar visas" +
          (data.cached ? " (cache)" : "") + ".");
        openSharedPopupIfAny();
        fetchWeatherAdvice(c.lat, c.lng);
      })
      .catch(function (err) {
        hereBtn.disabled = false;
        showStatus("Kunde inte hämta data: " + err.message);
      });

    if (showChargers) searchChargers();
    if (showBicycles) searchBicycles();
  }

  function searchChargers() {
    var c = map.getCenter();
    if (map.getZoom() < 12) return;
    api("chargers.php?lat=" + c.lat.toFixed(6) + "&lng=" + c.lng.toFixed(6) + "&radius=" + currentRadius())
      .then(function (data) { renderChargers(data.elements || []); })
      .catch(function () { /* tyst */ });
  }

  function searchBicycles() {
    var c = map.getCenter();
    if (map.getZoom() < 12) return;
    api("bicycle_parking.php?lat=" + c.lat.toFixed(6) + "&lng=" + c.lng.toFixed(6) + "&radius=" + currentRadius())
      .then(function (data) { renderBicycles(data.elements || []); })
      .catch(function () { /* tyst */ });
  }

  var chargerChip = document.getElementById("chargerChip");
  chargerChip.addEventListener("click", function () {
    showChargers = !showChargers;
    chargerChip.setAttribute("aria-pressed", showChargers ? "true" : "false");
    updateMoreChip();
    if (showChargers) {
      chargerLayer.addTo(map);
      searchChargers();
      showStatus("Visar laddstationer.");
    } else {
      map.removeLayer(chargerLayer);
    }
  });

  var bicycleChip = document.getElementById("bicycleChip");
  bicycleChip.addEventListener("click", function () {
    showBicycles = !showBicycles;
    bicycleChip.setAttribute("aria-pressed", showBicycles ? "true" : "false");
    updateMoreChip();
    if (showBicycles) {
      bicycleLayer.addTo(map);
      searchBicycles();
      showStatus("Visar cykelparkeringar.");
    } else {
      map.removeLayer(bicycleLayer);
    }
  });

  /* Taxelagret. Sitter i "Fler filter"-arket som de andra extralagren, och
     räknas därmed automatiskt in i räknaren på chippet – ett påslaget lager
     får aldrig vara osynligt tillstånd. */
  var tariffChip = document.getElementById("tariffChip");
  tariffChip.addEventListener("click", function () {
    tariffLinesVisible = !tariffLinesVisible;
    tariffChip.setAttribute("aria-pressed", tariffLinesVisible ? "true" : "false");
    updateMoreChip();
    if (tariffLinesVisible) {
      tariffLayer.addTo(map);
      renderTariffLegend();
      loadTariffGeometry();
    } else {
      map.removeLayer(tariffLayer);
      renderTariffLegend();
    }
  });

  var disabledChip = document.getElementById("disabledChip");
  disabledChip.addEventListener("click", function () {
    showDisabled = !showDisabled;
    disabledChip.setAttribute("aria-pressed", showDisabled ? "true" : "false");
    updateMoreChip();
    if (showDisabled) {
      disabledLayer.addTo(map);
      // Datan kommer redan med i den senaste sökningen (ltf_zones,
      // samma anrop som betalzonerna) - ingen egen fetch behövs, bara
      // rendera om det vi redan har och/eller söka om ifall vi ännu
      // inte hämtat något alls för det synliga området.
      renderDisabledParking(lastLtfZones);
      showStatus("Visar handikapparkering.");
    } else {
      map.removeLayer(disabledLayer);
    }
  });

  /* ================= Favoriter + konto ================= */
  function loadFavorites() {
    api("favorites.php").then(function (data) {
      favorites = {};
      favList.innerHTML = "";
      if (!data.favorites.length) {
        favList.innerHTML = '<p class="favempty">Inga favoriter ännu. Öppna en parkering på kartan och tryck på stjärnan.</p>';
        return;
      }
      var lastFolder; // undefined != null, så första gruppen (mappen null) alltid får en rubrik
      data.favorites.forEach(function (f) {
        favorites[f.osm_type + "/" + f.osm_id] = true;

        if (f.folder !== lastFolder) {
          lastFolder = f.folder;
          var head = document.createElement("div");
          head.className = "favfolderhead";
          head.textContent = f.folder || "Utan mapp";
          favList.appendChild(head);
        }

        var row = document.createElement("div");
        row.className = "favitem";
        row.innerHTML = '<div class="fname"><strong>' + esc(f.name || "Parkering") +
          "</strong><small>" + (f.fee === "no" ? "Gratis" : f.fee === "yes" ? "Avgift" : "Okänd taxa") +
          (f.note ? " · " + esc(f.note) : "") + "</small></div>";

        if (f.lat != null) {
          var go = document.createElement("button");
          go.textContent = "Visa";
          go.addEventListener("click", function () {
            hideCities();
            favPanel.hidden = true;
            map.setView([f.lat, f.lon], 17);
            setTimeout(searchParking, 400);
          });
          row.appendChild(go);
        }
        var moveBtn = document.createElement("button");
        moveBtn.textContent = "Flytta";
        moveBtn.title = "Flytta till mapp";
        moveBtn.addEventListener("click", function () {
          var current = f.folder || "";
          var next = prompt("Vilken mapp ska \"" + (f.name || "parkeringen") + "\" ligga i? " +
            "(lämna tomt för att ta bort ur mapp)", current);
          if (next === null) return; // avbrutet
          api("favorites.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ osm_type: f.osm_type, osm_id: +f.osm_id, note: f.note || "", folder: next.trim() })
          }).then(loadFavorites);
        });
        row.appendChild(moveBtn);
        var del = document.createElement("button");
        del.textContent = "Ta bort";
        del.className = "del";
        del.addEventListener("click", function () {
          api("favorites.php", {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ osm_type: f.osm_type, osm_id: +f.osm_id })
          }).then(loadFavorites);
        });
        row.appendChild(del);
        favList.appendChild(row);
      });
    }).catch(function () { /* tyst */ });
  }

  function refreshContributions() {
    api("my_contributions.php").then(function (d) {
      var total = d.stats.zones + d.stats.prices + d.stats.reports;
      var box = document.getElementById("contribBox");
      if (total === 0) { box.hidden = true; return; }
      box.hidden = false;
      var parts = [];
      if (d.stats.zones) parts.push(d.stats.zones + " zonkod" + (d.stats.zones > 1 ? "er" : ""));
      if (d.stats.prices) parts.push(d.stats.prices + " prisrapport" + (d.stats.prices > 1 ? "er" : ""));
      if (d.stats.reports) parts.push(d.stats.reports + " felrapport" + (d.stats.reports > 1 ? "er" : ""));
      box.textContent = "Du har bidragit med " + parts.join(", ") + "!";
    }).catch(function () {});
  }

  function refreshAccount() {
    api("auth.php").then(function (d) {
      document.getElementById("accountLoggedOut").hidden = d.logged_in;
      document.getElementById("accountLoggedIn").hidden = !d.logged_in;
      if (d.logged_in) document.getElementById("accountEmail").textContent = d.email;
    }).catch(function () {});
  }
  document.getElementById("loginBtn").addEventListener("click", function () {
    var email = document.getElementById("loginEmail").value.trim();
    if (!email) { showStatus("Ange din e-postadress."); return; }
    api("auth.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "request", email: email })
    }).then(function (d) { showStatus(d.message || "Länk skickad!"); })
      .catch(function (err) { showStatus(err.message); });
  });
  document.getElementById("logoutBtn").addEventListener("click", function () {
    api("auth.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "logout" })
    }).then(function () { refreshAccount(); loadFavorites(); showStatus("Utloggad."); });
  });

  document.getElementById("favBtn").addEventListener("click", function () {
    favPanel.hidden = !favPanel.hidden;
    if (!favPanel.hidden) { loadFavorites(); refreshAccount(); refreshContributions(); }
  });
  document.getElementById("favClose").addEventListener("click", function () {
    favPanel.hidden = true;
  });

  /* ================= Geokodning ================= */
  var qInput = document.getElementById("q");
  var resultsEl = document.getElementById("results");

  function setDestination(lat, lon, name) {
    destination = { lat: lat, lon: lon, name: name };
    if (destMarker) map.removeLayer(destMarker);
    destMarker = L.marker([lat, lon], {
      icon: L.divIcon({ className: "", html: '<div class="destmarker"></div>',
        iconSize: [18, 18], iconAnchor: [9, 9] }),
      title: name || "Mål", zIndexOffset: 1000
    }).bindPopup("<strong>" + esc(name || "Mål") + "</strong>").addTo(map);
  }

  function doSearch() {
    var text = qInput.value.trim();
    if (!text) return;
    showStatus("Söker…", true);
    api("geocode.php?q=" + encodeURIComponent(text))
      .then(function (data) {
        hideStatus();
        resultsEl.innerHTML = "";
        if (!data.hits.length) {
          showStatus("Inga träffar i Sverige på ”" + text + "”.");
          resultsEl.style.display = "none";
          return;
        }
        data.hits.forEach(function (hit) {
          var b = document.createElement("button");
          b.className = "result";
          b.setAttribute("role", "option");
          var parts = hit.display_name.split(",");
          b.innerHTML = "<strong>" + esc(parts[0]) + "</strong><small>" +
            esc(parts.slice(1).join(",").trim()) + "</small>";
          b.addEventListener("click", function () {
            resultsEl.style.display = "none";
            hideCities();
            setDestination(+hit.lat, +hit.lon, parts[0]);
            map.setView([+hit.lat, +hit.lon], 15);
            setTimeout(function () {
              searchParking();
              listPanel.hidden = false; // visa gå-tidslistan direkt
            }, 400);
          });
          resultsEl.appendChild(b);
        });
        resultsEl.style.display = "block";
      })
      .catch(function (err) { showStatus("Sökningen misslyckades: " + err.message); });
  }
  document.getElementById("searchBtn").addEventListener("click", doSearch);
  qInput.addEventListener("keydown", function (e) { if (e.key === "Enter") doSearch(); });

  /* Sökförslag medan man skriver: samma doSearch()/resultsEl-flöde som
     redan fanns för Enter/sök-knappen, bara triggat automatiskt efter en
     kort paus i skrivandet istället för att kräva ett explicit tryck.
     Debounce (400ms) + minst 3 tecken, så vi inte spammar Nominatim-
     proxyn (geocode.php, som redan cachar men ändå) på varje tangenttryck. */
  var searchDebounceTimer = null;
  qInput.addEventListener("input", function () {
    clearTimeout(searchDebounceTimer);
    var text = qInput.value.trim();
    if (text.length < 3) {
      resultsEl.style.display = "none";
      return;
    }
    searchDebounceTimer = setTimeout(doSearch, 400);
  });
  document.addEventListener("click", function (e) {
    if (!resultsEl.contains(e.target) && e.target !== qInput) resultsEl.style.display = "none";
  });

  /* ================= Geolocation ================= */
  function locate() {
    if (!navigator.geolocation) { showStatus("Din webbläsare stöder inte platstjänster."); return; }
    showStatus("Hämtar din position…", true);
    navigator.geolocation.getCurrentPosition(function (pos) {
      hideCities();
      map.setView([pos.coords.latitude, pos.coords.longitude], 15);
      setTimeout(searchParking, 400);
    }, function () {
      showStatus("Kunde inte hämta position. Tillåt platsåtkomst och försök igen.");
    }, { enableHighAccuracy: true, timeout: 10000 });
  }
  document.getElementById("geoBtn").addEventListener("click", locate);
  document.getElementById("cityGeo").addEventListener("click", locate);

  /* ================= Stadsknappar & filter ================= */
  document.querySelectorAll(".city[data-c]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var p = btn.dataset.c.split(",");
      hideCities();
      map.setView([+p[0], +p[1]], +p[2]);
      setTimeout(searchParking, 400);
    });
  });
  document.querySelectorAll(".chip[data-f]").forEach(function (chip) {
    chip.addEventListener("click", function () {
      activeFilter = chip.dataset.f;
      document.querySelectorAll(".chip[data-f]").forEach(function (c) {
        c.setAttribute("aria-pressed", c === chip ? "true" : "false");
      });
      var shown = render();
      updateMoreChip();
      if (allSpots.length) showStatus(shown + " parkeringar matchar filtret.");
    });
  });

  /* ================= "Fler filter" =================
     De sex minst använda filtren ligger i ett utfällbart ark i stället för
     i chip-raden. Räknaren på knappen finns för att ett aktivt filter
     annars kunde ligga dolt i arket utan någon synlig ledtråd om varför
     kartan visar färre parkeringar än väntat – det vore samma sorts tysta
     tillstånd som resten av det här projektet redan blivit bitet av.
     Höjden på headern mäts om efter varje växling, eftersom --header-h
     styr var de flytande knapparna och bannerna hamnar. */
  var moreChip = document.getElementById("moreChip");
  var moreFilters = document.getElementById("moreFilters");
  var moreCount = document.getElementById("moreCount");
  function updateMoreChip() {
    var active = moreFilters.querySelectorAll('.chip[aria-pressed="true"]').length;
    moreCount.textContent = active ? String(active) : "";
    moreCount.hidden = active === 0;
    moreChip.classList.toggle("has-active", active > 0);
  }
  /* Priserna i teckenförklaringen är tidsberoende: står appen öppen över
     ett taxeskifte (t.ex. kl. 19) blir siffrorna tysta lögner. Ritas därför
     om varje minut medan lagret är påslaget. */
  setInterval(function () { if (tariffLinesVisible) renderTariffLegend(); }, 60000);

  moreChip.addEventListener("click", function () {
    var open = moreFilters.hidden;
    moreFilters.hidden = !open;
    moreChip.setAttribute("aria-expanded", open ? "true" : "false");
    updateHeaderHeightVar();
  });

  hereBtn.addEventListener("click", function () { hideCities(); searchParking(); });

  /* Service workern cachar redan API-svar och karttiles allteftersom de
     hämtas (se sw.js) – den här knappen gör inget tekniskt nytt, men
     tvingar fram en färsk hämtning av ALLT synligt just nu (parkeringar +
     ev. aktiva extralager) och ger en tydlig bekräftelse, så att man
     vet att området faktiskt är redo innan man tappar täckning. */
  document.getElementById("offlineBtn").addEventListener("click", function () {
    if (map.getZoom() < 12) { showStatus("Zooma in på området du vill spara först."); return; }
    showStatus("Sparar det här området för offline-användning…", true);
    searchParking();
    if (showChargers) searchChargers();
    if (showBicycles) searchBicycles();
    setTimeout(function () {
      showStatus("Klart! Parkeringarna i det här området är sparade och syns även utan uppkoppling.");
    }, 900);
  });

  /* ================= Auto-hämtning vid kartrörelse ================= */
  var autoFetchTimer = null;
  var lastFetchCenter = null;
  function scheduleAutoFetch() {
    if (citiesEl.style.display !== "none") return; // vänta tills en stad/plats valts
    if (map.getZoom() < 12) return;
    clearTimeout(autoFetchTimer);
    autoFetchTimer = setTimeout(function () {
      var c = map.getCenter();
      // Hoppa över om kartan knappt rört sig sedan senaste hämtningen
      if (lastFetchCenter && haversine(c.lat, c.lng, lastFetchCenter.lat, lastFetchCenter.lng) < 150) return;
      lastFetchCenter = { lat: c.lat, lng: c.lng };
      searchParking();
    }, 600);
  }
  map.on("moveend zoomend", scheduleAutoFetch);

  /* ================= Dela-länk: öppna popup från ?p=type/id eller ?zone=kod ================= */
  var pendingShareKey = null;
  var pendingZoneCode = null;
  function openSharedPopupIfAny() {
    if (pendingShareKey) {
      var mk = markerByKey[pendingShareKey];
      if (mk) { mk.openPopup(); pendingShareKey = null; }
    }
    if (pendingZoneCode) {
      var zmk = zoneMarkerByCode[pendingZoneCode];
      if (zmk) { zmk.openPopup(); pendingZoneCode = null; }
    }
  }

  /* ================= Kom ihåg var jag parkerade ================= */
  var REMEMBER_KEY = "parkera_remember_v1";
  var rememberBtn = document.getElementById("rememberBtn");
  var rememberBanner = document.getElementById("rememberBanner");
  var rememberText = document.getElementById("rememberText");
  var parkedMarker = null;

  function loadRemembered() {
    try { return JSON.parse(localStorage.getItem(REMEMBER_KEY) || "null"); }
    catch (e) { return null; }
  }
  function saveRemembered(v) {
    try {
      if (v) localStorage.setItem(REMEMBER_KEY, JSON.stringify(v));
      else localStorage.removeItem(REMEMBER_KEY);
    } catch (e) { /* privat läge etc – strunta i det */ }
  }
  function renderRemembered() {
    var r = loadRemembered();
    if (parkedMarker) { map.removeLayer(parkedMarker); parkedMarker = null; }
    if (!r) {
      rememberBanner.hidden = true;
      rememberBtn.classList.remove("active");
      updateHeaderHeightVar();
      return;
    }

    rememberBtn.classList.add("active");
    rememberBanner.hidden = false;
    var mins = Math.round((Date.now() - r.at) / 60000);
    var timeStr = mins < 60 ? mins + " min sedan" : Math.round(mins / 60) + " tim sedan";
    rememberText.textContent = "Parkerad " + timeStr +
      (r.note ? " · " + r.note : "");

    parkedMarker = L.marker([r.lat, r.lon], {
      icon: L.divIcon({ className: "", html: '<div class="parkedmarker">' + icon("psign", 26) + "</div>",
        iconSize: [30, 30], iconAnchor: [15, 28] }),
      zIndexOffset: 900
    }).addTo(map).bindPopup("Här parkerade du");
    updateHeaderHeightVar();
  }
  rememberBtn.addEventListener("click", function () {
    var existing = loadRemembered();
    if (existing) { renderRemembered(); map.setView([existing.lat, existing.lon], 17); return; }
    if (!navigator.geolocation) { showStatus("Din webbläsare stöder inte platstjänster."); return; }
    showStatus("Sparar din position…", true);
    navigator.geolocation.getCurrentPosition(function (pos) {
      saveRemembered({ lat: pos.coords.latitude, lon: pos.coords.longitude, at: Date.now() });
      renderRemembered();
      showStatus("Plats sparad – du hittar tillbaka via knappen.");
    }, function () {
      showStatus("Kunde inte hämta position. Tillåt platsåtkomst och försök igen.");
    }, { enableHighAccuracy: true, timeout: 10000 });
  });
  document.getElementById("rememberGo").addEventListener("click", function () {
    var r = loadRemembered();
    if (!r) return;
    window.open("https://www.google.com/maps/dir/?api=1&destination=" + r.lat + "," + r.lon, "_blank");
  });
  document.getElementById("rememberClear").addEventListener("click", function () {
    saveRemembered(null);
    renderRemembered();
    showStatus("Platsen borttagen.");
  });

  /* ================= Dela läge (realtidsdelning) =================
     Delar den redan sparade "kom ihåg"-platsen live via en länk som INTE
     kräver att mottagaren har appen eller ett eget konto. Länken pekar
     mot den SENASTE positionen (uppdateras om man flyttar bilen), inte
     en engångsbild - se schema.sql/SharedLocationRepository för GDPR-
     resonemanget kring varför token:et är separat från ägarens eget. */
  document.getElementById("rememberShare").addEventListener("click", function () {
    var r = loadRemembered();
    if (!r) { showStatus("Spara en plats med knappen \"Minns platsen\" först."); return; }
    api("share_location.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ lat: r.lat, lon: r.lon, label: r.note || null, hours: 4 })
    }).then(function (d) {
      var url = location.origin + location.pathname + "?share=" + d.share_token;
      document.getElementById("shareLocationLink").value = url;
      document.getElementById("shareLocationModal").hidden = false;
    }).catch(function (err) { showStatus(err.message); });
  });
  document.getElementById("shareLocationClose").addEventListener("click", function () {
    document.getElementById("shareLocationModal").hidden = true;
  });
  document.getElementById("shareLocationCopy").addEventListener("click", function () {
    var input = document.getElementById("shareLocationLink");
    input.select();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(input.value).then(function () { showStatus("Länk kopierad!"); });
    } else {
      document.execCommand("copy");
      showStatus("Länk kopierad!");
    }
  });
  document.getElementById("shareLocationRevoke").addEventListener("click", function () {
    api("share_location.php", { method: "DELETE" }).then(function () {
      document.getElementById("shareLocationModal").hidden = true;
      showStatus("Delningen avslutad – länken visar inte längre din plats.");
    });
  });

  /* Mottagarsidan: ?share=TOKEN i URL:en - ingen inloggning, inget eget
     konto behövs. Pollar var 20:e sekund så positionen syns leva om
     ägaren flyttar bilen medan man tittar. */
  var sharedLocationMarker = null;
  var sharedLocationPoll = null;
  function loadSharedLocation(token) {
    api("share_location.php?token=" + encodeURIComponent(token)).then(function (d) {
      var banner = document.getElementById("sharedLocationBanner");
      if (!d.location) {
        banner.hidden = false;
        banner.textContent = "Den här delade platsen finns inte längre eller har gått ut.";
        clearInterval(sharedLocationPoll);
        return;
      }
      var loc = d.location;
      banner.hidden = false;
      banner.textContent = (loc.label || "Delad plats") + " – uppdaterad " +
        new Date(loc.updated_at.replace(" ", "T")).toLocaleTimeString("sv-SE", { hour: "2-digit", minute: "2-digit" });

      var isFirstLoad = !sharedLocationMarker;
      if (sharedLocationMarker) map.removeLayer(sharedLocationMarker);
      sharedLocationMarker = L.marker([loc.lat, loc.lon], {
        icon: L.divIcon({ className: "", html: '<div class="parkedmarker sharedmarker">' + icon("pin", 26) + "</div>",
          iconSize: [30, 30], iconAnchor: [15, 28] }),
        zIndexOffset: 950
      }).addTo(map).bindPopup(esc(loc.label || "Delad plats"));
      if (isFirstLoad) map.setView([loc.lat, loc.lon], 16);
    }).catch(function () {});
  }

  /* ================= Betald till-timer ================= */
  var timerBtn = document.getElementById("timerBtn");
  var timerBanner = document.getElementById("timerBanner");
  var timerPicker = document.getElementById("timerPicker");

  function refreshTimer() {
    api("parking_timer.php").then(function (d) {
      if (d.timer) {
        var mins = Math.max(0, Math.round((new Date(d.timer.expires_at.replace(" ", "T")) - Date.now()) / 60000));
        timerBtn.classList.add("active");
        timerBanner.hidden = false;
        document.getElementById("timerText").textContent =
          mins > 0 ? "Betald " + (mins < 60 ? mins + " min" : Math.round(mins / 60) + " tim") + " till"
                    : "Tiden har gått ut";
      } else {
        timerBtn.classList.remove("active");
        timerBanner.hidden = true;
      }
    }).catch(function () {});
  }

  timerBtn.addEventListener("click", function () {
    timerPicker.hidden = !timerPicker.hidden;
  });
  document.getElementById("timerCancel").addEventListener("click", function () {
    timerPicker.hidden = true;
  });
  document.querySelectorAll("#timerPicker .timerchoices button").forEach(function (b) {
    b.addEventListener("click", function () {
      var c = map.getCenter();
      var body = { lat: c.lat, lon: c.lng, minutes: +b.dataset.min };
      // Om en destination redan är satt (sökt en adress) skickas den med,
      // så påminnelsen kan räkna ut en ledtid baserad på verklig gångtid
      // TILLBAKA dit istället för en fast tid för alla.
      if (destination) { body.dest_lat = destination.lat; body.dest_lon = destination.lon; }
      api("parking_timer.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      }).then(function () {
        timerPicker.hidden = true;
        refreshTimer();
        showStatus("Timer satt – vi påminner dig innan tiden går ut (om notiser är aktiverade).");
      }).catch(function (err) { showStatus(err.message); });
    });
  });
  document.getElementById("timerClear").addEventListener("click", function () {
    api("parking_timer.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "clear" })
    }).then(refreshTimer);
  });

  /* ================= Push-notiser ================= */
  function urlBase64ToUint8Array(base64) {
    var padding = "=".repeat((4 - (base64.length % 4)) % 4);
    var base64safe = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
    var raw = atob(base64safe), out = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
    return out;
  }

  var pushBox = document.getElementById("pushBox");
  var pushToggle = document.getElementById("pushToggle");
  var pushInfo = null;

  function initPush() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
    api("push.php").then(function (d) {
      pushInfo = d;
      if (!d.available) return;
      pushBox.hidden = false;
      navigator.serviceWorker.ready.then(function (reg) {
        reg.pushManager.getSubscription().then(function (sub) {
          pushToggle.checked = !!sub;
        });
      });
    }).catch(function () {});
  }

  pushToggle && pushToggle.addEventListener("change", function () {
    if (!pushInfo || !pushInfo.available) { pushToggle.checked = false; return; }
    navigator.serviceWorker.ready.then(function (reg) {
      if (pushToggle.checked) {
        Notification.requestPermission().then(function (perm) {
          if (perm !== "granted") { pushToggle.checked = false; return; }
          reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(pushInfo.public_key)
          }).then(function (sub) {
            return api("push.php", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ subscription: sub.toJSON(), threshold: 10 })
            });
          }).then(function () { showStatus("Notiser aktiverade för dina favoriter."); })
            .catch(function () { pushToggle.checked = false; showStatus("Kunde inte aktivera notiser."); });
        });
      } else {
        reg.pushManager.getSubscription().then(function (sub) {
          if (!sub) return;
          var endpoint = sub.endpoint;
          sub.unsubscribe().then(function () {
            return api("push.php", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ action: "unsubscribe", endpoint: endpoint })
            });
          }).then(function () { showStatus("Notiser avstängda."); });
        });
      }
    });
  });

  /* ================= Init: läs URL-parametrar (från Om/stadssidor eller delad länk) ================= */
  (function initFromUrl() {
    var params = new URLSearchParams(location.search);
    var lat = parseFloat(params.get("lat"));
    var lng = parseFloat(params.get("lng"));
    var zoom = parseInt(params.get("zoom"), 10) || 16;
    var p = params.get("p");
    var zone = params.get("zone");
    var share = params.get("share");

    if (p) pendingShareKey = p;
    if (zone) pendingZoneCode = zone;

    if (!isNaN(lat) && !isNaN(lng)) {
      hideCities();
      map.setView([lat, lng], (p || zone) ? Math.max(zoom, 17) : zoom);
      setTimeout(searchParking, 350);
    }

    if (share) {
      hideCities();
      loadSharedLocation(share);
      sharedLocationPoll = setInterval(function () { loadSharedLocation(share); }, 20000);
    }
  })();

  /* ================= Onboarding för förstagångsbesökare =================
     Många funktioner (betald-till-timer, crowdsourcad snabbrapportering,
     "Parkera här" i popupen) ligger i en redan tät meny och är lätta att
     missa för en ny användare. En kort, valbar genomgång - visas EN gång
     (localStorage-flagga), går alltid att hoppa över direkt. */
  var ONBOARDING_SLIDES_SV = [
    { title: "Välkommen till Parkera i Sverige", body: "Gratis karta över parkeringar, p-hus, laddstationer och infartsparkeringar i hela landet – lediga platser i realtid där kommunen delar den datan." },
    { title: "Filtrera med chipsen", body: "Tryck på \"Gratis\", \"Avgift\", \"P-hus\" eller någon av de andra chipsen högst upp för att bara visa det du är ute efter." },
    { title: "Kom ihåg var du parkerade", body: "Tryck på nålknappen till höger – eller \"Parkera här\" direkt i en parkerings popup – så hittar du tillbaka även i ett stort garage." },
    { title: "Betald till-timer", body: "Sätt en timer när du betalat, så påminner vi dig (om du aktiverat notiser) innan tiden går ut." },
    { title: "Hjälp andra hitta rätt", body: "Ser du fel i kartan, eller en zonkod som saknas? Öppna en parkering och använd \"Bidra med information\", eller \"Föreslå zonkod\" i menyn – granskas innan det visas för andra." }
  ];
  var ONBOARDING_SLIDES = ONBOARDING_SLIDES_SV;
  var onboardingIndex = 0;
  var onboardingEl = document.getElementById("onboarding");

  function renderOnboardingSlide() {
    var slide = ONBOARDING_SLIDES[onboardingIndex];
    document.getElementById("onboardingSlides").innerHTML =
      "<h2>" + esc(slide.title) + "</h2><p>" + esc(slide.body) + "</p>";
    document.getElementById("onboardingDots").innerHTML = ONBOARDING_SLIDES.map(function (_, i) {
      return '<span class="dot' + (i === onboardingIndex ? " on" : "") + '"></span>';
    }).join("");
    document.getElementById("onboardingBack").hidden = onboardingIndex === 0;
    document.getElementById("onboardingNext").textContent =
      onboardingIndex === ONBOARDING_SLIDES.length - 1 ? "Kom igång" : "Nästa";
  }
  function closeOnboarding() {
    onboardingEl.hidden = true;
    // Stadväljaren och kakbannern har väntat bakom onboardingen – släpp
    // fram dem först nu, en i taget, i stället för tre lager samtidigt.
    citiesEl.hidden = false;
    showCookieBanner();
    localStorage.setItem("parkera_onboarded_v1", "1");
  }
  document.getElementById("onboardingSkip").addEventListener("click", closeOnboarding);
  document.getElementById("onboardingNext").addEventListener("click", function () {
    if (onboardingIndex < ONBOARDING_SLIDES.length - 1) {
      onboardingIndex++;
      renderOnboardingSlide();
    } else {
      closeOnboarding();
    }
  });
  document.getElementById("onboardingBack").addEventListener("click", function () {
    if (onboardingIndex > 0) {
      onboardingIndex--;
      renderOnboardingSlide();
    }
  });
  /* Första besöket visade tidigare tre lager samtidigt: onboardingdialogen,
     stadväljaren bakom den och kakbannern ovanpå båda. Nu en sekvens:
     onboarding -> stadväljare + kakbanner. Stadväljaren döljs med [hidden]
     (inte style.display), just för att scheduleAutoFetch tittar på
     style.display för att avgöra om en plats valts – den ska fortsätta
     vänta medan onboardingen är uppe, inte börja hämta i bakgrunden. */
  if (!localStorage.getItem("parkera_onboarded_v1")) {
    citiesEl.hidden = true;
    renderOnboardingSlide();
    onboardingEl.hidden = false;
  } else {
    showCookieBanner();
  }

  renderRemembered();
  refreshTimer();
  initPush();
  loadProviderStatus();
  loadFavorites();
  refreshAccount();

  // Sparat val vinner alltid; annars: engelska bara om webbläsaren
  // uttryckligen inte är svensk, för att inte överraska majoriteten av
  // användarna (som är i Sverige) med fel språk av misstag.
  var savedLang = localStorage.getItem("parkera_lang");
  var browserLang = (navigator.language || "sv").toLowerCase();
  applyLanguage(savedLang || (browserLang.indexOf("sv") === 0 ? "sv" : "en"));
})();
